// src/index.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@scottish-government/pattern-library/dist/css/pattern-library.css";
// src/lib/components/SSC/alert/alert.tsx
import { useState } from "react";
import { Alert } from "react-bootstrap";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AlertBox = function(alertProps) {
    var _useState = _sliced_to_array(useState(true), 2), show = _useState[0], setShow = _useState[1];
    return /* @__PURE__ */ jsx(Fragment, {
        children: show && /* @__PURE__ */ jsxs(Alert, {
            variant: alertProps.type,
            onClose: function() {
                return setShow(false);
            },
            dismissible: true,
            children: [
                /* @__PURE__ */ jsx(Alert.Heading, {
                    children: alertProps.header
                }),
                /* @__PURE__ */ jsx("p", {
                    children: alertProps.message
                })
            ]
        })
    });
};
// src/lib/components/SSC/header/header.tsx
import { useState as useState2 } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var Header = function(headerProps) {
    var _useState2 = _sliced_to_array(useState2(false), 2), expanded = _useState2[0], setExpanded = _useState2[1];
    var menuExpansion = function(trueOrFalse) {
        setTimeout(function() {
            setExpanded(trueOrFalse);
        }, 150);
    };
    return /* @__PURE__ */ jsxs2(Navbar, {
        collapseOnSelect: true,
        expand: "lg",
        variant: "light",
        sticky: "top",
        expanded: expanded,
        className: "ds_site-header justify-content-between",
        children: [
            /* @__PURE__ */ jsx2(Navbar.Brand, {
                as: Link,
                to: headerProps.brandLink ? headerProps.brandLink : "/",
                className: "ds_site-header__content",
                children: /* @__PURE__ */ jsxs2("div", {
                    className: "ds_site-branding d-flex flex-row",
                    children: [
                        /* @__PURE__ */ jsxs2("div", {
                            className: "ds_site-branding__logo ds_site-branding__link header-link ps-3",
                            children: [
                                /* @__PURE__ */ jsx2("img", {
                                    className: "ds_site-branding__logo-image header-image d-none d-sm-block",
                                    src: headerProps.logoImageAddress,
                                    alt: "Scottish Courts logo"
                                }),
                                /* @__PURE__ */ jsx2("img", {
                                    className: "ds_site-branding__logo-image header-image-small d-block d-sm-none",
                                    src: headerProps.logoImageAddress,
                                    alt: "Scottish Courts logo"
                                })
                            ]
                        }),
                        headerProps.headerText !== "" && /* @__PURE__ */ jsxs2("div", {
                            className: "d-flex flex-row",
                            children: [
                                /* @__PURE__ */ jsx2("div", {
                                    className: "ps-5 pe-2 d-none d-sm-block header-text header-title",
                                    children: headerProps.headerText
                                }),
                                /* @__PURE__ */ jsx2("div", {
                                    className: "ps-4 pe-0 d-block d-sm-none header-text-mobile header-title",
                                    children: headerProps.headerText
                                })
                            ]
                        })
                    ]
                })
            }),
            /* @__PURE__ */ jsxs2(Fragment2, {
                children: [
                    /* @__PURE__ */ jsx2(Navbar.Toggle, {
                        "aria-controls": "responsive-navbar-nav",
                        className: "collapsed",
                        onClick: function() {
                            return setExpanded(!expanded);
                        }
                    }),
                    /* @__PURE__ */ jsx2(Navbar.Collapse, {
                        id: "responsive-navbar-nav",
                        children: /* @__PURE__ */ jsxs2(Nav, {
                            className: "me-auto mt-2",
                            children: [
                                headerProps.menuItems && headerProps.menuItems.map(function(menuItem, index) {
                                    return /* @__PURE__ */ jsx2(Link, {
                                        to: menuItem.routeUri,
                                        onClick: function() {
                                            return menuExpansion(false);
                                        },
                                        children: /* @__PURE__ */ jsx2("span", {
                                            className: "link-text",
                                            children: menuItem.displayText
                                        })
                                    }, index.toString());
                                }),
                                /* @__PURE__ */ jsx2(Fragment2, {
                                    children: headerProps.dropdownMenuItems && headerProps.dropdownMenuItems.length > 0 && headerProps.dropdownMenuItems.map(function(ddMenuItem, index) {
                                        return /* @__PURE__ */ jsx2(Nav.Link, {
                                            eventKey: "1000" + index.toString(),
                                            href: ddMenuItem.isHref ? ddMenuItem.routeUri : ddMenuItem.isCallback ? "" : ddMenuItem.routeUri,
                                            onClick: function() {
                                                var _headerProps_childLogoutFunction;
                                                menuExpansion(false);
                                                if (ddMenuItem.isCallback) (_headerProps_childLogoutFunction = headerProps.childLogoutFunction) === null || _headerProps_childLogoutFunction === void 0 ? void 0 : _headerProps_childLogoutFunction.call(headerProps, true);
                                            },
                                            children: /* @__PURE__ */ jsx2("span", {
                                                className: "link-text",
                                                children: ddMenuItem.displayText
                                            })
                                        }, 100 + index);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
// src/lib/components/SSC/form-detail/form-detail.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var FormItem = function(props) {
    return /* @__PURE__ */ jsxs3("div", {
        className: "d-flex flex-row form-item",
        style: {
            marginBottom: props.marginBottom
        },
        children: [
            (props.header || props.headerIcon) && /* @__PURE__ */ jsxs3("dt", {
                className: props.headerIcon + " font-weight-bold item-header",
                style: {
                    minWidth: props.minWidthHeader
                },
                children: [
                    props.header,
                    " "
                ]
            }),
            /* @__PURE__ */ jsxs3("dd", {
                className: (props.detailIcon ? props.detailIcon : "") + " item-detail",
                "data-testid": "item-detail-testid",
                style: {
                    minWidth: props.minWidthDetail,
                    boxShadow: props.ignoreBoxShadow ? "none" : "",
                    overflowWrap: "anywhere"
                },
                children: [
                    props.isEmail && /* @__PURE__ */ jsx3("a", {
                        href: "mailto:" + props.detail,
                        children: props.detail
                    }),
                    props.isPhone && /* @__PURE__ */ jsx3("a", {
                        href: "tel:" + props.detail,
                        children: props.detail
                    }),
                    !props.isEmail && !props.isPhone && props.detail,
                    " "
                ]
            })
        ]
    });
};
// src/lib/components/SSC/form-header/form-header.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var FormHeader = function(props) {
    return /* @__PURE__ */ jsxs4("div", {
        className: "d-flex flex-row font-weight-bold form-header-wrapper",
        children: [
            props.icon && /* @__PURE__ */ jsx4("i", {
                className: props.icon + "fs-1 pe-2"
            }),
            /* @__PURE__ */ jsxs4("h3", {
                className: "fs-5 pt-2",
                children: [
                    " ",
                    props.detail
                ]
            })
        ]
    });
};
// src/lib/components/SSC/page-header/page-header.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var PageHeader = function(props) {
    return /* @__PURE__ */ jsxs5("h2", {
        className: "d-flex flex-row page-header",
        children: [
            props.icon && /* @__PURE__ */ jsx5("i", {
                className: props.icon + " header-icon pe-2"
            }),
            props.detail
        ]
    });
};
// src/lib/components/SSC/footer/footer.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var Footer = function(footerProps) {
    return /* @__PURE__ */ jsx6("div", {
        className: "scts-footer",
        style: {
            backgroundColor: footerProps.backgroundColour,
            color: footerProps.colour,
            padding: footerProps.padding,
            paddingBottom: footerProps.paddingBottom
        },
        children: /* @__PURE__ */ jsx6("div", {
            className: "d-flex flex-row pb-1",
            children: /* @__PURE__ */ jsx6("ul", {
                className: "d-flex flex-row mb-0 ps-0 flex-wrap",
                style: {
                    listStyle: "none"
                },
                children: footerProps.links.map(function(link, index) {
                    return /* @__PURE__ */ jsx6("li", {
                        className: "me-3",
                        children: /* @__PURE__ */ jsxs6("a", {
                            href: link.url,
                            target: "_blank",
                            style: {
                                textDecoration: "underline",
                                color: footerProps.colour
                            },
                            rel: "noreferrer",
                            children: [
                                link.name,
                                link.showIcon && /* @__PURE__ */ jsx6("i", {
                                    className: "bi bi-box-arrow-up-right ms-1",
                                    style: {
                                        textDecoration: "none"
                                    }
                                })
                            ]
                        })
                    }, index.toString());
                })
            })
        })
    });
};
// src/lib/components/errorSimple/error-simple.tsx
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var ErrorSimple = function(props) {
    return /* @__PURE__ */ jsxs7("div", {
        className: "simple-error-wrapper d-flex flex-row",
        style: {
            padding: props.padding,
            margin: props.margin
        },
        children: [
            /* @__PURE__ */ jsx7("i", {
                className: "simple-error-icon bi " + props.icon + " me-1",
                style: {
                    fontSize: props.iconFontSize
                }
            }),
            /* @__PURE__ */ jsxs7("span", {
                className: "simple-error-text ms-2",
                style: {
                    fontSize: props.textFontSize
                },
                children: [
                    " ",
                    props.message,
                    " "
                ]
            })
        ]
    });
};
// src/lib/components/linkbox-component/footer-linkbox.tsx
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var LinkboxComponent = function(links) {
    return /* @__PURE__ */ jsxs8("div", {
        className: "linkbox d-flex flex-column flex-fill",
        children: [
            /* @__PURE__ */ jsxs8("div", {
                className: "title",
                children: [
                    links.title,
                    " "
                ]
            }),
            /* @__PURE__ */ jsx8("hr", {}),
            /* @__PURE__ */ jsx8("ul", {
                className: "ds_site-footer__site-items d-flex flex-column ",
                children: links.links.map(function(link, index) {
                    return /* @__PURE__ */ jsxs8("li", {
                        className: "ds_site-items__item",
                        children: [
                            /* @__PURE__ */ jsx8("a", {
                                href: link.href,
                                target: link.external ? "_blank" : "_self",
                                rel: "noreferrer",
                                children: link.name
                            }),
                            " ",
                            "\xA0",
                            link.external && /* @__PURE__ */ jsx8("i", {
                                className: "bi bi-box-arrow-up-right"
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var footer_linkbox_default = LinkboxComponent;
// src/lib/components/footers/footer-multi/footer-multi.tsx
import { jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var FooterMulti = function(footerProps) {
    return /* @__PURE__ */ jsx9("footer", {
        className: "ds_site-footer",
        style: {
            backgroundColor: footerProps.backgroundColour,
            color: footerProps.colour,
            padding: footerProps.padding,
            paddingBottom: footerProps.paddingBottom
        },
        children: /* @__PURE__ */ jsxs9("div", {
            className: "ds_wrapper",
            children: [
                /* @__PURE__ */ jsx9("div", {
                    className: "d-flex flex-row",
                    children: /* @__PURE__ */ jsx9("div", {
                        className: "col1 d-flex flex-column justify-content-center",
                        style: {
                            flex: "50%"
                        },
                        children: /* @__PURE__ */ jsxs9("div", {
                            className: "linkbox-container d-flex flex-column d-md-flex flex-md-row",
                            children: [
                                /* @__PURE__ */ jsx9(footer_linkbox_default, {
                                    links: footerProps.col1Links1.links,
                                    title: footerProps.col1Links1.title
                                }),
                                /* @__PURE__ */ jsx9(footer_linkbox_default, {
                                    links: footerProps.col1Links2.links,
                                    title: " - "
                                }),
                                /* @__PURE__ */ jsx9(footer_linkbox_default, {
                                    links: footerProps.col2Links1.links,
                                    title: footerProps.col2Links1.title
                                }),
                                /* @__PURE__ */ jsx9(footer_linkbox_default, {
                                    links: footerProps.col2Links2.links,
                                    title: " - "
                                })
                            ]
                        })
                    })
                }),
                /* @__PURE__ */ jsx9("hr", {}),
                /* @__PURE__ */ jsx9("div", {
                    className: "ds_site-footer__copyright",
                    children: footerProps.copyrightMessage && /* @__PURE__ */ jsxs9("p", {
                        className: "fs-5",
                        children: [
                            "\xA9 \xA0",
                            footerProps.copyrightMessage,
                            " ",
                            /* @__PURE__ */ new Date().getFullYear()
                        ]
                    })
                })
            ]
        })
    });
};
// src/lib/components/footers/footer-sg/footer-sg.tsx
import { jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var FooterSg = function(footerProps) {
    return /* @__PURE__ */ jsx10("footer", {
        className: "ds_site-footer footer-single",
        style: {
            backgroundColor: footerProps.backgroundColour,
            color: footerProps.colour,
            padding: footerProps.padding,
            paddingBottom: footerProps.paddingBottom
        },
        children: /* @__PURE__ */ jsxs10("div", {
            className: "ds_wrapper",
            children: [
                /* @__PURE__ */ jsx10("ul", {
                    className: "ds_site-footer__site-items",
                    children: footerProps.links.map(function(link, index) {
                        return /* @__PURE__ */ jsx10("li", {
                            className: "ds_site-items__item",
                            children: /* @__PURE__ */ jsxs10("a", {
                                href: link.url,
                                target: link.external ? "_blank" : "_self",
                                rel: "noreferrer",
                                children: [
                                    link.name,
                                    link.showIcon && /* @__PURE__ */ jsx10("i", {
                                        className: "bi bi-box-arrow-up-right ms-1",
                                        style: {
                                            textDecoration: "none"
                                        }
                                    })
                                ]
                            })
                        }, index.toString());
                    })
                }),
                footerProps.copyrightMessage && /* @__PURE__ */ jsx10("div", {
                    className: "ds_site-footer__copyright",
                    children: /* @__PURE__ */ jsxs10("p", {
                        className: "fs-5",
                        children: [
                            "\xA9 \xA0",
                            footerProps.copyrightMessage,
                            " ",
                            /* @__PURE__ */ new Date().getFullYear()
                        ]
                    })
                })
            ]
        })
    });
};
// src/lib/components/header-sg/header-sg.tsx
import { Link as Link2 } from "react-router-dom";
import { useState as useState3 } from "react";
import { jsx as jsx11, jsxs as jsxs11 } from "react/jsx-runtime";
var HeaderSg = function(headerProps) {
    var logo = "../../assets/component-images/scts-logo.png";
    var logoSmall = "../../assets/component-images/scts-logo-sm.png";
    var _useState3 = _sliced_to_array(useState3(headerProps.headerMenuItems.length + headerProps.headerSpecialMenuItems.length), 1), numMenuItems = _useState3[0];
    var ariaExpandedFalse = false;
    var ariaExpandedTrue = true;
    var _useState31 = _sliced_to_array(useState3(ariaExpandedFalse), 2), ariaExpanded = _useState31[0], setAriaExpanded = _useState31[1];
    var menuOpenClasses = "ds_site-header__control js-toggle-menu ds_link ds_site-header__control--active";
    var menuClosedClasses = "ds_site-header__control js-toggle-menu ds_link";
    var mobileMenuCloseClasses = "ds_site-navigation ds_site-navigation--mobile";
    var mobileMenuOpenClasses = "ds_site-navigation ds_site-navigation--mobile ds_site-navigation--open";
    var _useState32 = _sliced_to_array(useState3(menuClosedClasses), 2), menuCurrentClasses = _useState32[0], setMenuCurrentClasses = _useState32[1];
    var _useState33 = _sliced_to_array(useState3(mobileMenuCloseClasses), 2), mobileMenuClasses = _useState33[0], setmobileMenuClasses = _useState33[1];
    var _useState34 = _sliced_to_array(useState3(new Array(numMenuItems).fill(false)), 2), headerSelectedItems = _useState34[0], setHeaderSelectedItems = _useState34[1];
    var _useState35 = _sliced_to_array(useState3(new Array(numMenuItems).fill("")), 2), currentClassItems = _useState35[0], setCurrentClassItems = _useState35[1];
    var headerItemSelected = function(itemSelected) {
        var newArray = new Array(numMenuItems).fill(false);
        var newCurrentArray = new Array(numMenuItems).fill("");
        for(var index = 0; index < numMenuItems; index++){
            if (itemSelected === index) {
                newArray[index] = true;
                newCurrentArray[index] = " ds_current ";
            }
        }
        setHeaderSelectedItems(newArray);
        setCurrentClassItems(newCurrentArray);
    };
    var mobileMenu = function() {
        if (menuCurrentClasses === menuClosedClasses) {
            setMenuCurrentClasses(menuOpenClasses);
            setmobileMenuClasses(mobileMenuOpenClasses);
            setAriaExpanded(ariaExpandedTrue);
        } else {
            setMenuCurrentClasses(menuClosedClasses);
            setmobileMenuClasses(mobileMenuCloseClasses);
            setAriaExpanded(ariaExpandedFalse);
        }
    };
    var getNavigationListCode = function() {
        return /* @__PURE__ */ jsxs11("ul", {
            className: "ds_site-navigation__list",
            children: [
                headerProps.headerMenuItems.map(function(item, index) {
                    return /* @__PURE__ */ jsx11("li", {
                        className: "ds_site-navigation__item",
                        children: /* @__PURE__ */ jsx11(Link2, {
                            to: item.routeUri,
                            className: "ds_site-navigation__link " + currentClassItems[index],
                            onClick: function() {
                                return headerItemSelected(index);
                            },
                            children: /* @__PURE__ */ jsx11("span", {
                                className: "link-text",
                                children: item.displayText
                            })
                        })
                    }, index.toString());
                }),
                headerProps.headerSpecialMenuItems.map(function(item, index) {
                    return /* @__PURE__ */ jsx11("li", {
                        className: "ds_site-navigation__item",
                        children: /* @__PURE__ */ jsx11("a", {
                            href: item.isHref ? item.routeUri : item.isCallback ? "#" : item.routeUri,
                            className: "ds_site-navigation__link " + currentClassItems[index + headerProps.headerMenuItems.length],
                            onClick: function() {
                                var _headerProps_parentCallbackFunction;
                                if (item.isCallback) (_headerProps_parentCallbackFunction = headerProps.parentCallbackFunction) === null || _headerProps_parentCallbackFunction === void 0 ? void 0 : _headerProps_parentCallbackFunction.call(headerProps, true);
                            },
                            children: /* @__PURE__ */ jsx11("span", {
                                className: "link-text",
                                children: item.displayText
                            })
                        })
                    }, index + headerProps.headerMenuItems.length);
                })
            ]
        });
    };
    return /* @__PURE__ */ jsxs11("header", {
        className: "ds_site-header  ds_site-header--gradient",
        role: "banner",
        children: [
            /* @__PURE__ */ jsx11("div", {
                className: "ds_wrapper",
                children: /* @__PURE__ */ jsxs11("div", {
                    className: "ds_site-header__content",
                    children: [
                        /* @__PURE__ */ jsxs11("div", {
                            className: "ds_site-branding",
                            children: [
                                /* @__PURE__ */ jsxs11(Link2, {
                                    to: headerProps.brandLink ? headerProps.brandLink : "/",
                                    className: "ds_site-branding__logo  ds_site-branding__link",
                                    children: [
                                        /* @__PURE__ */ jsx11("img", {
                                            className: "ds_site-branding__logo-image d-none d-md-block",
                                            src: headerProps.logoImageAddress ? headerProps.logoImageAddress : logo,
                                            alt: headerProps.imageAltText
                                        }),
                                        /* @__PURE__ */ jsx11("img", {
                                            className: "ds_site-branding__logo-image header-image-small d-block d-md-none",
                                            src: headerProps.logoSmallImageAddress ? headerProps.logoSmallImageAddress : logoSmall,
                                            alt: headerProps.imageAltText
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ jsx11("div", {
                                    className: "ds_site-branding__title d-none d-sm-block",
                                    children: headerProps.headerText
                                }),
                                /* @__PURE__ */ jsx11("div", {
                                    className: "ds_site-branding__title d-block d-sm-none",
                                    children: headerProps.headerTextMobile
                                })
                            ]
                        }),
                        !(headerProps.headerMenuItems.length === 0 && headerProps.headerSpecialMenuItems.length === 0) && /* @__PURE__ */ jsx11("div", {
                            className: "ds_site-header__controls",
                            onClick: function() {
                                return mobileMenu();
                            },
                            children: /* @__PURE__ */ jsxs11("button", {
                                className: menuCurrentClasses,
                                "aria-controls": "mobile-navigation",
                                "aria-expanded": ariaExpanded,
                                "data-button": "button-menu",
                                "data-header": "header-menu-toggle",
                                children: [
                                    /* @__PURE__ */ jsx11("span", {
                                        className: "ds_site-header__control-text",
                                        children: "Menu"
                                    }),
                                    /* @__PURE__ */ jsx11("img", {
                                        className: "ds_icon  ds_site-header__control-icon",
                                        "aria-hidden": "true",
                                        src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IS0tIFVwbG9hZGVkIHRvOiBTVkcgUmVwbywgd3d3LnN2Z3JlcG8uY29tLCBHZW5lcmF0b3I6IFNWRyBSZXBvIE1peGVyIFRvb2xzIC0tPg0KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik00IDE4TDIwIDE4IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8cGF0aCBkPSJNNCAxMkwyMCAxMiIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPHBhdGggZD0iTTQgNkwyMCA2IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8L3N2Zz4=",
                                        alt: "burger menu icon"
                                    }),
                                    /* @__PURE__ */ jsx11("img", {
                                        className: "ds_icon  ds_site-header__control-icon  ds_site-header__control-icon--active-icon",
                                        "aria-hidden": "true",
                                        src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+Cjxzdmcgd2lkdGg9IjgwMHB4IiBoZWlnaHQ9IjgwMHB4IiB2aWV3Qm94PSIwIDAgNi4zNDk5OTk4IDYuMzQ5OTk5OCIgaWQ9InN2ZzgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnMgaWQ9ImRlZnMyIi8+PHBhdGggZD0ibSAwLjc2MzY3MzM2LDAuNTI3MzQzNzUgYSAwLjI2NDYwOTc4LDAuMjY0NjA5NzggMCAwIDAgLTAuMTU2MjUsMC40NTMxMjUwMSBMIDUuMzY5MTQyLDUuNzQ0MTQwNSBBIDAuMjY1MTY1MDQsMC4yNjUxNjUwNCAwIDEgMCA1Ljc0NDE0MjEsNS4zNjkxNDA3IEwgMC45ODA0NzAyNCwwLjYwNzQyMTg4IEEgMC4yNjQ2MDk3OCwwLjI2NDYwOTc4IDAgMCAwIDAuNzYzNjczMzYsMC41MjczNDM3NSBaIiBpZD0icGF0aDE4NTUiIHN0eWxlPSJjb2xvcjojMDAwMDAwO2ZvbnQtc3R5bGU6bm9ybWFsO2ZvbnQtdmFyaWFudDpub3JtYWw7Zm9udC13ZWlnaHQ6bm9ybWFsO2ZvbnQtc3RyZXRjaDpub3JtYWw7Zm9udC1zaXplOm1lZGl1bTtsaW5lLWhlaWdodDpub3JtYWw7Zm9udC1mYW1pbHk6c2Fucy1zZXJpZjtmb250LXZhcmlhbnQtbGlnYXR1cmVzOm5vcm1hbDtmb250LXZhcmlhbnQtcG9zaXRpb246bm9ybWFsO2ZvbnQtdmFyaWFudC1jYXBzOm5vcm1hbDtmb250LXZhcmlhbnQtbnVtZXJpYzpub3JtYWw7Zm9udC12YXJpYW50LWFsdGVybmF0ZXM6bm9ybWFsO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpub3JtYWw7dGV4dC1pbmRlbnQ6MDt0ZXh0LWFsaWduOnN0YXJ0O3RleHQtZGVjb3JhdGlvbjpub25lO3RleHQtZGVjb3JhdGlvbi1saW5lOm5vbmU7dGV4dC1kZWNvcmF0aW9uLXN0eWxlOnNvbGlkO3RleHQtZGVjb3JhdGlvbi1jb2xvcjojMDAwMDAwO2xldHRlci1zcGFjaW5nOm5vcm1hbDt3b3JkLXNwYWNpbmc6bm9ybWFsO3RleHQtdHJhbnNmb3JtOm5vbmU7d3JpdGluZy1tb2RlOmxyLXRiO2RpcmVjdGlvbjpsdHI7dGV4dC1vcmllbnRhdGlvbjptaXhlZDtkb21pbmFudC1iYXNlbGluZTphdXRvO2Jhc2VsaW5lLXNoaWZ0OmJhc2VsaW5lO3RleHQtYW5jaG9yOnN0YXJ0O3doaXRlLXNwYWNlOm5vcm1hbDtzaGFwZS1wYWRkaW5nOjA7Y2xpcC1ydWxlOm5vbnplcm87ZGlzcGxheTppbmxpbmU7b3ZlcmZsb3c6dmlzaWJsZTt2aXNpYmlsaXR5OnZpc2libGU7b3BhY2l0eToxO2lzb2xhdGlvbjphdXRvO21peC1ibGVuZC1tb2RlOm5vcm1hbDtjb2xvci1pbnRlcnBvbGF0aW9uOnNSR0I7Y29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzOmxpbmVhclJHQjtzb2xpZC1jb2xvcjojMDAwMDAwO3NvbGlkLW9wYWNpdHk6MTt2ZWN0b3ItZWZmZWN0Om5vbmU7ZmlsbDojMDAwMDFkO2ZpbGwtb3BhY2l0eToxO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpub25lO3N0cm9rZS13aWR0aDowLjUyOTE2NjY0O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDo0O3N0cm9rZS1kYXNoYXJyYXk6bm9uZTtzdHJva2UtZGFzaG9mZnNldDoyMDQuMDk0NDgyNDI7c3Ryb2tlLW9wYWNpdHk6MTtwYWludC1vcmRlcjpzdHJva2UgZmlsbCBtYXJrZXJzO2NvbG9yLXJlbmRlcmluZzphdXRvO2ltYWdlLXJlbmRlcmluZzphdXRvO3NoYXBlLXJlbmRlcmluZzphdXRvO3RleHQtcmVuZGVyaW5nOmF1dG87ZW5hYmxlLWJhY2tncm91bmQ6YWNjdW11bGF0ZSIvPjxwYXRoIGQ9Ik0gNS41NTA3ODI3LDAuNTI3MzQzNzUgQSAwLjI2NDYwOTc4LDAuMjY0NjA5NzggMCAwIDAgNS4zNjkxNDIsMC42MDc0MjE4OCBMIDAuNjA3NDIzMzYsNS4zNjkxNDA3IEEgMC4yNjQ2MDk3OCwwLjI2NDYwOTc4IDAgMSAwIDAuOTgwNDcwMjQsNS43NDQxNDA1IEwgNS43NDQxNDIxLDAuOTgwNDY4NzYgQSAwLjI2NDYwOTc4LDAuMjY0NjA5NzggMCAwIDAgNS41NTA3ODI3LDAuNTI3MzQzNzUgWiIgaWQ9InBhdGgxODU3IiBzdHlsZT0iY29sb3I6IzAwMDAwMDtmb250LXN0eWxlOm5vcm1hbDtmb250LXZhcmlhbnQ6bm9ybWFsO2ZvbnQtd2VpZ2h0Om5vcm1hbDtmb250LXN0cmV0Y2g6bm9ybWFsO2ZvbnQtc2l6ZTptZWRpdW07bGluZS1oZWlnaHQ6bm9ybWFsO2ZvbnQtZmFtaWx5OnNhbnMtc2VyaWY7Zm9udC12YXJpYW50LWxpZ2F0dXJlczpub3JtYWw7Zm9udC12YXJpYW50LXBvc2l0aW9uOm5vcm1hbDtmb250LXZhcmlhbnQtY2Fwczpub3JtYWw7Zm9udC12YXJpYW50LW51bWVyaWM6bm9ybWFsO2ZvbnQtdmFyaWFudC1hbHRlcm5hdGVzOm5vcm1hbDtmb250LWZlYXR1cmUtc2V0dGluZ3M6bm9ybWFsO3RleHQtaW5kZW50OjA7dGV4dC1hbGlnbjpzdGFydDt0ZXh0LWRlY29yYXRpb246bm9uZTt0ZXh0LWRlY29yYXRpb24tbGluZTpub25lO3RleHQtZGVjb3JhdGlvbi1zdHlsZTpzb2xpZDt0ZXh0LWRlY29yYXRpb24tY29sb3I6IzAwMDAwMDtsZXR0ZXItc3BhY2luZzpub3JtYWw7d29yZC1zcGFjaW5nOm5vcm1hbDt0ZXh0LXRyYW5zZm9ybTpub25lO3dyaXRpbmctbW9kZTpsci10YjtkaXJlY3Rpb246bHRyO3RleHQtb3JpZW50YXRpb246bWl4ZWQ7ZG9taW5hbnQtYmFzZWxpbmU6YXV0bztiYXNlbGluZS1zaGlmdDpiYXNlbGluZTt0ZXh0LWFuY2hvcjpzdGFydDt3aGl0ZS1zcGFjZTpub3JtYWw7c2hhcGUtcGFkZGluZzowO2NsaXAtcnVsZTpub256ZXJvO2Rpc3BsYXk6aW5saW5lO292ZXJmbG93OnZpc2libGU7dmlzaWJpbGl0eTp2aXNpYmxlO29wYWNpdHk6MTtpc29sYXRpb246YXV0bzttaXgtYmxlbmQtbW9kZTpub3JtYWw7Y29sb3ItaW50ZXJwb2xhdGlvbjpzUkdCO2NvbG9yLWludGVycG9sYXRpb24tZmlsdGVyczpsaW5lYXJSR0I7c29saWQtY29sb3I6IzAwMDAwMDtzb2xpZC1vcGFjaXR5OjE7dmVjdG9yLWVmZmVjdDpub25lO2ZpbGw6IzAwMDAxZDtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZTtzdHJva2Utd2lkdGg6MC41MjkxNjY2NDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6NDtzdHJva2UtZGFzaGFycmF5Om5vbmU7c3Ryb2tlLWRhc2hvZmZzZXQ6MjA0LjA5NDQ4MjQyO3N0cm9rZS1vcGFjaXR5OjE7cGFpbnQtb3JkZXI6c3Ryb2tlIGZpbGwgbWFya2Vycztjb2xvci1yZW5kZXJpbmc6YXV0bztpbWFnZS1yZW5kZXJpbmc6YXV0bztzaGFwZS1yZW5kZXJpbmc6YXV0bzt0ZXh0LXJlbmRlcmluZzphdXRvO2VuYWJsZS1iYWNrZ3JvdW5kOmFjY3VtdWxhdGUiLz48L3N2Zz4=",
                                        alt: "close icon"
                                    })
                                ]
                            })
                        }),
                        /* @__PURE__ */ jsx11("input", {
                            className: "ds_site-navigation__toggle",
                            id: "menu",
                            type: "checkbox",
                            title: "Menu toggle"
                        }),
                        /* @__PURE__ */ jsx11("nav", {
                            id: "mobile-navigation",
                            className: mobileMenuClasses,
                            "data-module": "ds-mobile-navigation-menu",
                            children: getNavigationListCode()
                        })
                    ]
                })
            }),
            /* @__PURE__ */ jsx11("div", {
                className: "ds_site-header__navigation",
                children: /* @__PURE__ */ jsx11("div", {
                    className: "ds_wrapper",
                    children: /* @__PURE__ */ jsx11("nav", {
                        className: "ds_site-navigation",
                        children: getNavigationListCode()
                    })
                })
            })
        ]
    });
};
// src/lib/components/loader/loader.tsx
import classNames from "classnames";
import { Fragment as Fragment3, jsx as jsx12, jsxs as jsxs12 } from "react/jsx-runtime";
var Loader = function(param) {
    var loadingText = param.loadingText, padding = param.padding, size = param.size, _param_variant = param.variant, variant = _param_variant === void 0 ? "dark" : _param_variant;
    return /* @__PURE__ */ jsxs12(Fragment3, {
        children: [
            size === "sm" && /* @__PURE__ */ jsx12(SmallLoader, {
                loadingText: loadingText,
                size: "sm",
                variant: variant
            }),
            size !== "sm" && /* @__PURE__ */ jsx12(DefaultLoader, {
                padding: padding,
                loadingText: loadingText,
                variant: variant
            })
        ]
    });
};
var loader_default = Loader;
var DefaultLoader = function(param) {
    var loadingText = param.loadingText, padding = param.padding, _param_variant = param.variant, variant = _param_variant === void 0 ? "dark" : _param_variant;
    return /* @__PURE__ */ jsx12("div", {
        className: "container-fluid d-flex flex-column h-100",
        id: "root-animation",
        "data-testid": "loader-container",
        style: {
            padding: padding
        },
        children: /* @__PURE__ */ jsx12(SmallLoader, {
            loadingText: loadingText,
            variant: variant
        })
    });
};
var SmallLoader = function(param) {
    var loadingText = param.loadingText, size = param.size, _param_variant = param.variant, variant = _param_variant === void 0 ? "dark" : _param_variant;
    return /* @__PURE__ */ jsxs12("div", {
        className: classNames(size === "sm" ? "spinner-sm" : "spinner", variant === "light" ? "light" : ""),
        "data-testid": "loader",
        children: [
            /* @__PURE__ */ jsx12("div", {
                className: "rect1"
            }),
            /* @__PURE__ */ jsx12("div", {
                className: "rect2"
            }),
            /* @__PURE__ */ jsx12("div", {
                className: "rect3"
            }),
            /* @__PURE__ */ jsx12("div", {
                className: "rect4"
            }),
            /* @__PURE__ */ jsx12("div", {
                className: "rect5"
            }),
            /* @__PURE__ */ jsx12("p", {
                children: loadingText
            })
        ]
    });
};
// src/lib/components/not-found/not-found.tsx
import { Link as Link3 } from "react-router-dom";
import { jsx as jsx13, jsxs as jsxs13 } from "react/jsx-runtime";
var NotFound = function(props) {
    return /* @__PURE__ */ jsxs13("div", {
        className: "notfound-wrapper",
        style: {
            padding: props.padding,
            margin: props.margin,
            paddingTop: props.paddingTop
        },
        children: [
            /* @__PURE__ */ jsx13("h1", {
                className: "text-massive",
                children: "Oops!"
            }),
            /* @__PURE__ */ jsx13("h2", {
                children: "The page you're looking for does not exist."
            }),
            /* @__PURE__ */ jsxs13("p", {
                children: [
                    /* @__PURE__ */ jsx13("span", {
                        className: "fw-bold",
                        children: "Error code: "
                    }),
                    " #404 - Page Not Found!"
                ]
            }),
            /* @__PURE__ */ jsx13("p", {
                children: "Some options: "
            }),
            /* @__PURE__ */ jsx13("div", {
                className: "notfound-links",
                children: props.links.length > 0 && props.links.map(function(notfoundLink, index) {
                    return /* @__PURE__ */ jsx13("div", {
                        children: /* @__PURE__ */ jsxs13(Link3, {
                            className: "link",
                            to: notfoundLink.linkRoute,
                            children: [
                                /* @__PURE__ */ jsx13("i", {
                                    className: "bi " + notfoundLink.icon + " me-2"
                                }),
                                notfoundLink.linkText
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
};
// src/lib/components/tab-component/tab-component/tab-component.tsx
import { Tabs, Tab } from "react-bootstrap";
import { jsx as jsx14 } from "react/jsx-runtime";
var TabComponent = function(tabProps) {
    return /* @__PURE__ */ jsx14("div", {
        className: "scts-tabs",
        children: /* @__PURE__ */ jsx14(Tabs, {
            defaultActiveKey: tabProps.activeKey,
            transition: false,
            children: tabProps.tabs.map(function(tab) {
                return /* @__PURE__ */ jsx14(Tab, {
                    eventKey: tab.key,
                    title: tab.title,
                    children: /* @__PURE__ */ jsx14("div", {
                        className: "card",
                        children: /* @__PURE__ */ jsx14("div", {
                            className: "card-body",
                            dangerouslySetInnerHTML: {
                                __html: tab.content
                            }
                        })
                    })
                }, tab.key);
            })
        })
    });
};
// src/lib/components/timeline/timeline.tsx
import { standardDateFormatter } from "utilitieststest";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { Fragment as Fragment4, jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
var Timeline = function(timelineProps) {
    return /* @__PURE__ */ jsx15("div", {
        className: "my-timeline-wrapper",
        children: /* @__PURE__ */ jsx15("div", {
            className: "card",
            children: /* @__PURE__ */ jsxs14("div", {
                className: "card-body",
                children: [
                    timelineProps.timeLines.length > 0 && /* @__PURE__ */ jsx15(VerticalTimeline, {
                        className: "vertical-timeline-custom-line",
                        children: timelineProps.timeLines.map(function(activity, index) {
                            return /* @__PURE__ */ jsx15(VerticalTimelineElement, {
                                className: "vertical-timeline-element--work",
                                contentStyle: {
                                    background: "rgb(33, 150, 243)",
                                    color: "#fff"
                                },
                                contentArrowStyle: {
                                    borderRight: "7px solid  rgb(33, 150, 243)"
                                },
                                date: standardDateFormatter(new Date(activity.dateTime)),
                                iconStyle: {
                                    background: "rgb(33, 150, 243)",
                                    color: "#fff"
                                },
                                icon: /* @__PURE__ */ jsx15("i", {
                                    className: "bi bi-info-lg"
                                }),
                                children: /* @__PURE__ */ jsxs14(Fragment4, {
                                    children: [
                                        /* @__PURE__ */ jsx15("h3", {
                                            className: "vertical-timeline-element-title fw-bold",
                                            children: activity.caseActivityType
                                        }),
                                        /* @__PURE__ */ jsx15("h4", {
                                            className: "vertical-timeline-element-subtitle fw-light",
                                            children: activity.title
                                        }),
                                        /* @__PURE__ */ jsx15("p", {
                                            children: activity.details
                                        }),
                                        activity.download && /* @__PURE__ */ jsxs14("p", {
                                            className: "fs-6",
                                            children: [
                                                "Download document: \xA0 ",
                                                activity.download
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    !timelineProps.timeLines || timelineProps.timeLines.length === 0 && /* @__PURE__ */ jsx15("p", {
                        className: "text-center",
                        children: "There are currently no timeline status updates for this case."
                    })
                ]
            })
        })
    });
};
// src/lib/components/timeline/timeline-steps.tsx
import { VerticalTimeline as VerticalTimeline2, VerticalTimelineElement as VerticalTimelineElement2 } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { jsx as jsx16, jsxs as jsxs15 } from "react/jsx-runtime";
var TimelineSteps = function(props) {
    return /* @__PURE__ */ jsxs15("div", {
        className: "my-timeline-wrapper process-timeline",
        children: [
            props.steps.length > 0 && /* @__PURE__ */ jsx16(VerticalTimeline2, {
                layout: "1-column-left",
                className: "vertical-timeline-custom-line",
                children: props.steps.map(function(step, index) {
                    return /* @__PURE__ */ jsxs15(VerticalTimelineElement2, {
                        className: "vertical-timeline-element--work",
                        contentStyle: {
                            background: "rgb(33, 150, 243)",
                            color: "#fff"
                        },
                        contentArrowStyle: {
                            borderRight: "7px solid  rgb(33, 150, 243)"
                        },
                        iconStyle: {
                            background: "rgb(33, 150, 243)",
                            color: "#fff"
                        },
                        icon: /* @__PURE__ */ jsxs15("span", {
                            className: "bespoke-icon",
                            children: [
                                " ",
                                step.step
                            ]
                        }),
                        children: [
                            /* @__PURE__ */ jsx16("h3", {
                                className: "vertical-timeline-element-subtitle fw-light",
                                children: step.title
                            }),
                            /* @__PURE__ */ jsx16("pre", {
                                children: step.body
                            })
                        ]
                    }, index);
                })
            }),
            !props.steps || props.steps.length === 0 && /* @__PURE__ */ jsx16("p", {
                className: "text-center",
                children: "There are currently no timeline status updates for this case."
            })
        ]
    });
};
// src/lib/components/paging-sg/paging-sg-link.tsx
import { Fragment as Fragment5, jsx as jsx17, jsxs as jsxs16 } from "react/jsx-runtime";
var GetPagingSgLinkElementMinus = function(minusProps) {
    return /* @__PURE__ */ jsx17("li", {
        className: "ds_pagination__item",
        children: /* @__PURE__ */ jsx17("a", {
            href: "#",
            className: "ds_pagination__link",
            onClick: function(e) {
                e.preventDefault();
                minusProps.pagingProps.pageClicked(minusProps.pageToClick - minusProps.pageAdjuster);
            },
            children: /* @__PURE__ */ jsx17("span", {
                className: "ds_pagination__link-label",
                children: minusProps.pageToClick - minusProps.pageAdjuster
            })
        })
    }, minusProps.index + 11e3);
};
var GetPagingSgLinkElementPlus = function(plusProps) {
    return /* @__PURE__ */ jsx17("li", {
        className: "ds_pagination__item",
        children: /* @__PURE__ */ jsx17("a", {
            href: "#",
            className: "ds_pagination__link",
            onClick: function(e) {
                e.preventDefault();
                plusProps.pagingProps.pageClicked(plusProps.pageToClick + plusProps.pageAdjuster);
            },
            children: /* @__PURE__ */ jsx17("span", {
                className: "ds_pagination__link-label",
                children: plusProps.pageToClick + plusProps.pageAdjuster
            })
        })
    }, plusProps.index + 12e3);
};
var GetPagingSgLinkElementPlusCurrent = function(currentProps) {
    return /* @__PURE__ */ jsx17("li", {
        className: "ds_pagination__item",
        "aria-current": "page",
        children: /* @__PURE__ */ jsx17("a", {
            className: "ds_pagination__link  ds_current",
            role: "button",
            children: currentProps.pageToClick + currentProps.pageAdjuster
        })
    }, currentProps.index + 13e3);
};
var GetPagingSgLEllipsis = function(ellipsisProps) {
    return /* @__PURE__ */ jsx17("li", {
        className: "ds_pagination__item",
        "aria-hidden": "true",
        children: /* @__PURE__ */ jsx17("span", {
            className: "ds_pagination__link  ds_pagination__link--ellipsis",
            children: "\u2026"
        })
    }, ellipsisProps.index + 14e3);
};
var GetPagingSgNextPrev = function(nextPrevProps) {
    return /* @__PURE__ */ jsx17("li", {
        className: "ds_pagination__item",
        children: /* @__PURE__ */ jsxs16("a", {
            href: "#",
            className: "ds_pagination__link  ds_pagination__link--text  ds_pagination__link--icon",
            "data-navigation": "link-external",
            "data-search": nextPrevProps.isNext ? "pagination-next" : "pagination-previous",
            onClick: function(e) {
                e.preventDefault();
                nextPrevProps.isNext ? nextPrevProps.pagingProps.pageClicked(nextPrevProps.pagingProps.currentPage + 1) : nextPrevProps.pagingProps.pageClicked(nextPrevProps.pagingProps.currentPage - 1);
            },
            children: [
                nextPrevProps.isNext && /* @__PURE__ */ jsxs16(Fragment5, {
                    children: [
                        /* @__PURE__ */ jsx17("span", {
                            className: "ds_pagination__link-label",
                            children: "Next"
                        }),
                        /* @__PURE__ */ jsx17("svg", {
                            className: "ds_icon",
                            "aria-hidden": "true",
                            role: "img",
                            children: /* @__PURE__ */ jsx17("use", {
                                href: "/assets/icons/icons.stack.svg#chevron_right"
                            })
                        })
                    ]
                }),
                !nextPrevProps.isNext && /* @__PURE__ */ jsxs16(Fragment5, {
                    children: [
                        /* @__PURE__ */ jsx17("svg", {
                            className: "ds_icon",
                            "aria-hidden": "true",
                            role: "img",
                            children: /* @__PURE__ */ jsx17("use", {
                                href: "/assets/icons/icons.stack.svg#chevron_left"
                            })
                        }),
                        /* @__PURE__ */ jsx17("span", {
                            className: "ds_pagination__link-label",
                            children: "Previous"
                        })
                    ]
                })
            ]
        })
    }, nextPrevProps.index + 15e3);
};
// src/lib/components/paging-sg/paging-sg.tsx
import { jsx as jsx18, jsxs as jsxs17 } from "react/jsx-runtime";
var PagingSg = function(pagingProps) {
    var firstPageLink = function() {
        var links = [];
        if (pagingProps.currentPage === 1) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlusCurrent, {
                index: 1,
                pageToClick: 1,
                pageAdjuster: 0
            }, 1));
        } else {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                index: 1,
                pageToClick: 1,
                pageAdjuster: 0,
                pagingProps: pagingProps
            }, 1));
        }
        return links;
    };
    var middleLinks = function() {
        var links = [];
        if (pagingProps.numberOfPages < 3) return links;
        if (pagingProps.numberOfPages < 6) {
            for(var i = 1; i < pagingProps.numberOfPages - 1; i++){
                if (i + 1 === pagingProps.currentPage) {
                    links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlusCurrent, {
                        index: i,
                        pageAdjuster: 1,
                        pageToClick: i
                    }, 2));
                } else {
                    links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                        index: i,
                        pageToClick: i,
                        pageAdjuster: 1,
                        pagingProps: pagingProps
                    }, 2));
                }
            }
            return links;
        }
        var currentPage = pagingProps.currentPage;
        if (currentPage > 2 && currentPage < pagingProps.numberOfPages) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementMinus, {
                index: 3,
                pageToClick: currentPage,
                pageAdjuster: 1,
                pagingProps: pagingProps
            }, 3));
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlusCurrent, {
                index: 4,
                pageToClick: currentPage,
                pageAdjuster: 0
            }, 4));
            if (currentPage + 1 < pagingProps.numberOfPages) {
                links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                    index: 5,
                    pageToClick: currentPage,
                    pageAdjuster: 1,
                    pagingProps: pagingProps
                }, 5));
            }
            return links;
        }
        if (currentPage === 2 && currentPage < pagingProps.numberOfPages) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlusCurrent, {
                index: 3,
                pageToClick: currentPage,
                pageAdjuster: 0
            }, 6));
            if (currentPage + 1 < pagingProps.numberOfPages) {
                links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                    index: 4,
                    pageToClick: currentPage,
                    pageAdjuster: 1,
                    pagingProps: pagingProps
                }, 7));
            }
            if (currentPage + 2 < pagingProps.numberOfPages) {
                links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                    index: 5,
                    pageToClick: currentPage,
                    pageAdjuster: 2,
                    pagingProps: pagingProps
                }, 8));
            }
            return links;
        }
        if (currentPage === pagingProps.numberOfPages) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementMinus, {
                index: 3,
                pageToClick: currentPage,
                pageAdjuster: 3,
                pagingProps: pagingProps
            }, 9));
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementMinus, {
                index: 4,
                pageToClick: currentPage,
                pageAdjuster: 2,
                pagingProps: pagingProps
            }, 10));
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementMinus, {
                index: 5,
                pageToClick: currentPage,
                pageAdjuster: 1,
                pagingProps: pagingProps
            }, 11));
            return links;
        }
        if (currentPage === 1) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                index: 3,
                pageToClick: currentPage,
                pageAdjuster: 1,
                pagingProps: pagingProps
            }, 12));
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                index: 4,
                pageToClick: currentPage,
                pageAdjuster: 2,
                pagingProps: pagingProps
            }, 13));
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                index: 5,
                pageToClick: currentPage,
                pageAdjuster: 3,
                pagingProps: pagingProps
            }, 14));
            return links;
        }
        return links;
    };
    var lastpageLink = function() {
        var links = [];
        if (pagingProps.numberOfPages > 1) {
            if (pagingProps.currentPage === pagingProps.numberOfPages) {
                links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlusCurrent, {
                    index: 1e3,
                    pageToClick: pagingProps.currentPage,
                    pageAdjuster: 0
                }, 15));
            } else {
                links.push(/* @__PURE__ */ jsx18(GetPagingSgLinkElementPlus, {
                    index: 1e3,
                    pageToClick: pagingProps.numberOfPages,
                    pageAdjuster: 0,
                    pagingProps: pagingProps
                }, 16));
            }
        }
        return links;
    };
    var previousLink = function() {
        var links = [];
        if (pagingProps.currentPage > 1) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgNextPrev, {
                isNext: false,
                index: 2e3,
                pagingProps: pagingProps
            }, 0));
        }
        return links;
    };
    var nextLink = function() {
        var links = [];
        if (pagingProps.numberOfPages > 1 && pagingProps.currentPage !== pagingProps.numberOfPages) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgNextPrev, {
                isNext: true,
                index: 1800,
                pagingProps: pagingProps
            }, 17));
        }
        return links;
    };
    var ellipsisLinksPrev = function() {
        var links = [];
        if (pagingProps.numberOfPages > pagingProps.numberOfPageLinks && pagingProps.currentPage > 2) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLEllipsis, {
                index: 600
            }, 18));
        }
        return links;
    };
    var ellipsisLinks = function() {
        var links = [];
        if (pagingProps.numberOfPages > pagingProps.numberOfPageLinks && pagingProps.currentPage !== pagingProps.numberOfPages) {
            links.push(/* @__PURE__ */ jsx18(GetPagingSgLEllipsis, {
                index: 700
            }, 19));
        }
        return links;
    };
    return /* @__PURE__ */ jsx18("nav", {
        className: "ds_pagination",
        "aria-label": "Result page",
        "aria-live": "polite",
        children: /* @__PURE__ */ jsxs17("ul", {
            className: "ds_pagination__list",
            children: [
                previousLink(),
                firstPageLink(),
                ellipsisLinksPrev(),
                middleLinks(),
                ellipsisLinks(),
                lastpageLink(),
                nextLink()
            ]
        })
    });
};
// src/lib/components/accordions/accordion-sg/accordion-sg.tsx
import { useState as useState4 } from "react";
import { jsx as jsx19, jsxs as jsxs18 } from "react/jsx-runtime";
var AccordionSg = function(accordionProps) {
    var displayBlock = "block";
    var displayNone = "none";
    var _useState4 = _sliced_to_array(useState4([
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone
    ]), 2), currentStyle = _useState4[0], setCurrentStyle = _useState4[1];
    var showBody = function(i) {
        var newArray = currentStyle.map(function(item, index) {
            if (index === i) {
                if (item === displayBlock) {
                    item = displayNone;
                } else {
                    item = displayBlock;
                }
            }
            return item;
        });
        setCurrentStyle(newArray);
    };
    var handleKeyPress = function(e, i) {
        if (e.key === "Enter" || e.key === " ") {
            showBody(i);
        }
    };
    return /* @__PURE__ */ jsx19("div", {
        className: "ds_accordion",
        "data-module": "ds-accordion",
        children: accordionProps && accordionProps.items.length > 0 && accordionProps.items.map(function(item, index) {
            return /* @__PURE__ */ jsxs18("div", {
                className: "ds_accordion-item",
                onKeyDown: function(e) {
                    return handleKeyPress(e, index);
                },
                children: [
                    /* @__PURE__ */ jsx19("input", {
                        type: "checkbox",
                        className: "visually-hidden  ds_accordion-item__control",
                        id: "panel-" + (index + 1),
                        "aria-labelledby": "panel-" + (index + 1) + "-heading"
                    }),
                    /* @__PURE__ */ jsxs18("div", {
                        className: "ds_accordion-item__header",
                        onClick: function() {
                            return showBody(index);
                        },
                        children: [
                            /* @__PURE__ */ jsx19("h3", {
                                id: "panel-" + (index + 1) + "-heading",
                                className: "ds_accordion-item__title",
                                children: item.title
                            }),
                            /* @__PURE__ */ jsx19("span", {
                                className: "ds_accordion-item__indicator"
                            }),
                            /* @__PURE__ */ jsx19("label", {
                                className: "ds_accordion-item__label",
                                htmlFor: "panel-" + (index + 1),
                                children: /* @__PURE__ */ jsx19("span", {
                                    className: "visually-hidden",
                                    children: "Show this section"
                                })
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsxs18("div", {
                        className: "ds_accordion-item__body",
                        style: {
                            display: currentStyle[index]
                        },
                        children: [
                            /* @__PURE__ */ jsx19("pre", {
                                children: item.body
                            }),
                            item.links && /* @__PURE__ */ jsx19("p", {
                                className: "mb-1",
                                children: "Links:"
                            }),
                            item.links && item.links.map(function(item2, index2) {
                                return /* @__PURE__ */ jsxs18("div", {
                                    className: "d-flex",
                                    children: [
                                        /* @__PURE__ */ jsx19("a", {
                                            href: item2.url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: item2.text
                                        }),
                                        /* @__PURE__ */ jsx19("br", {})
                                    ]
                                }, index2);
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
// src/lib/components/contact-sg/contact-sg.tsx
import { AppData } from "appdatats";
// src/lib/components/google-map/google-map.tsx
import { AddressLineFormatter } from "utilitieststest";
import { jsx as jsx20 } from "react/jsx-runtime";
var GoogleMap = function(googleMapProps) {
    var location = googleMapProps.address.addressLine1 + AddressLineFormatter(googleMapProps.address.townCity) + AddressLineFormatter(googleMapProps.address.postalCode);
    var googleSrc = "https://maps.google.com/maps?q=" + encodeURIComponent(location) + "&t=&z=13&ie=UTF8&iwloc=&output=embed";
    return /* @__PURE__ */ jsx20("iframe", {
        src: googleSrc,
        width: "100%",
        height: "100%",
        title: "Google Map",
        loading: "lazy"
    });
};
var google_map_default = GoogleMap;
// src/lib/components/contact-sg/contact-sg.tsx
import { jsx as jsx21, jsxs as jsxs19 } from "react/jsx-runtime";
var ContactSg = function(contactProps) {
    return /* @__PURE__ */ jsx21("div", {
        className: "ds_contact-details",
        children: /* @__PURE__ */ jsxs19("div", {
            className: "d-flex flex-md-row flex-column",
            children: [
                /* @__PURE__ */ jsxs19("dl", {
                    className: "ds_contact-details__list",
                    children: [
                        /* @__PURE__ */ jsxs19("div", {
                            className: "ds_contact-details__item",
                            children: [
                                /* @__PURE__ */ jsx21("dt", {
                                    children: "Address"
                                }),
                                /* @__PURE__ */ jsx21("dd", {
                                    translate: "no",
                                    children: /* @__PURE__ */ jsxs19("address", {
                                        children: [
                                            contactProps.orginisationName && /* @__PURE__ */ jsxs19("span", {
                                                children: [
                                                    contactProps.orginisationName,
                                                    " ",
                                                    /* @__PURE__ */ jsx21("br", {})
                                                ]
                                            }),
                                            contactProps.address.building && /* @__PURE__ */ jsxs19("span", {
                                                children: [
                                                    contactProps.address.building,
                                                    " ",
                                                    /* @__PURE__ */ jsx21("br", {})
                                                ]
                                            }),
                                            contactProps.address.addressLine1 && /* @__PURE__ */ jsxs19("span", {
                                                children: [
                                                    contactProps.address.addressLine1,
                                                    " ",
                                                    /* @__PURE__ */ jsx21("br", {})
                                                ]
                                            }),
                                            contactProps.address.addressLine2 && /* @__PURE__ */ jsxs19("span", {
                                                children: [
                                                    contactProps.address.addressLine2,
                                                    " ",
                                                    /* @__PURE__ */ jsx21("br", {})
                                                ]
                                            }),
                                            contactProps.address.addressLine3 && /* @__PURE__ */ jsxs19("span", {
                                                children: [
                                                    contactProps.address.addressLine3,
                                                    " ",
                                                    /* @__PURE__ */ jsx21("br", {})
                                                ]
                                            }),
                                            contactProps.address.townCity && /* @__PURE__ */ jsxs19("span", {
                                                children: [
                                                    contactProps.address.townCity,
                                                    " ",
                                                    /* @__PURE__ */ jsx21("br", {})
                                                ]
                                            }),
                                            contactProps.address.country && /* @__PURE__ */ jsxs19("span", {
                                                children: [
                                                    contactProps.address.country,
                                                    " ",
                                                    /* @__PURE__ */ jsx21("br", {})
                                                ]
                                            }),
                                            contactProps.address.postalCode && /* @__PURE__ */ jsxs19("span", {
                                                children: [
                                                    contactProps.address.postalCode,
                                                    " ",
                                                    /* @__PURE__ */ jsx21("br", {})
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        contactProps.email && /* @__PURE__ */ jsxs19("div", {
                            className: "ds_contact-details__item",
                            children: [
                                /* @__PURE__ */ jsx21("dt", {
                                    children: "Email"
                                }),
                                /* @__PURE__ */ jsx21("dd", {
                                    children: /* @__PURE__ */ jsx21("a", {
                                        href: "mailto:" + contactProps.email,
                                        children: contactProps.email
                                    })
                                })
                            ]
                        }),
                        contactProps.phone && /* @__PURE__ */ jsxs19("div", {
                            className: "ds_contact-details__item",
                            children: [
                                /* @__PURE__ */ jsx21("dt", {
                                    children: "Phone"
                                }),
                                /* @__PURE__ */ jsxs19("dd", {
                                    children: [
                                        /* @__PURE__ */ jsx21("a", {
                                            href: "tel:" + contactProps.phone,
                                            children: contactProps.phone
                                        }),
                                        /* @__PURE__ */ jsx21("br", {}),
                                        /* @__PURE__ */ jsx21("pre", {
                                            className: "mb-0 mt-2",
                                            children: contactProps.phoneText
                                        }),
                                        /* @__PURE__ */ jsx21("br", {}),
                                        "Find out about \xA0",
                                        /* @__PURE__ */ jsx21("a", {
                                            href: "https://www.gov.uk/call-charges",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "call charges"
                                        }),
                                        /* @__PURE__ */ jsx21("br", {})
                                    ]
                                })
                            ]
                        }),
                        contactProps.publicHolidayLink && /* @__PURE__ */ jsxs19("div", {
                            className: "ds_contact-details__item",
                            children: [
                                /* @__PURE__ */ jsx21("dt", {
                                    children: "Public Holidays"
                                }),
                                /* @__PURE__ */ jsxs19("dd", {
                                    children: [
                                        contactProps.publicHolidayText,
                                        /* @__PURE__ */ jsxs19("a", {
                                            href: contactProps.publicHolidayLink,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                " ",
                                                "Public Holidays"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        contactProps.complaints && /* @__PURE__ */ jsxs19("div", {
                            className: "ds_contact-details__item",
                            children: [
                                /* @__PURE__ */ jsx21("dt", {
                                    children: "Complaints"
                                }),
                                contactProps.complaints.map(function(complaint, index) {
                                    return /* @__PURE__ */ jsx21("dd", {
                                        children: /* @__PURE__ */ jsxs19("a", {
                                            href: complaint.url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                " ",
                                                complaint.name
                                            ]
                                        })
                                    }, index);
                                })
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ jsx21(google_map_default, {
                    address: AppData.contact.address
                })
            ]
        })
    });
};
// src/lib/components/page-header-sg/page-header-sg.tsx
import { jsx as jsx22, jsxs as jsxs20 } from "react/jsx-runtime";
var PageHeaderSg = function(props) {
    var _props_lastUpdatedDate;
    return /* @__PURE__ */ jsxs20("header", {
        className: "ds_page-header",
        children: [
            props.contentType && /* @__PURE__ */ jsx22("span", {
                className: "ds_page-header__label  ds_content-label",
                children: props.contentType
            }),
            /* @__PURE__ */ jsx22("h1", {
                className: "ds_page-header__title",
                children: props.headerText
            }),
            props.lastUpdatedDate && /* @__PURE__ */ jsx22("dl", {
                className: "ds_page-header__metadata  ds_metadata",
                children: /* @__PURE__ */ jsxs20("div", {
                    className: "ds_metadata__item",
                    children: [
                        /* @__PURE__ */ jsx22("dt", {
                            className: "ds_metadata__key",
                            children: "Last updated"
                        }),
                        /* @__PURE__ */ jsx22("dd", {
                            className: "ds_metadata__value",
                            children: (_props_lastUpdatedDate = props.lastUpdatedDate) === null || _props_lastUpdatedDate === void 0 ? void 0 : _props_lastUpdatedDate.toDateString()
                        })
                    ]
                })
            })
        ]
    });
};
var page_header_sg_default = PageHeaderSg;
// src/lib/components/modal/modal-static/modal-static.tsx
import { useState as useState5 } from "react";
import { Modal } from "react-bootstrap";
import { Fragment as Fragment6, jsx as jsx23, jsxs as jsxs21 } from "react/jsx-runtime";
var ModalStatic = function(param) {
    var contents = param.contents, children = param.children, icon = param.icon, text = param.text;
    var _useState5 = _sliced_to_array(useState5(false), 2), show = _useState5[0], setShow = _useState5[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    return /* @__PURE__ */ jsxs21(Fragment6, {
        children: [
            /* @__PURE__ */ jsxs21("a", {
                href: "javascript: void(0)",
                className: "modal-link",
                onClick: handleShow,
                children: [
                    children,
                    /* @__PURE__ */ jsx23("span", {
                        className: "modal-icon-or-text",
                        children: icon ? /* @__PURE__ */ jsx23("i", {
                            className: icon
                        }) : text
                    })
                ]
            }),
            /* @__PURE__ */ jsxs21(Modal, {
                show: show,
                onHide: handleClose,
                backdrop: "static",
                keyboard: true,
                children: [
                    /* @__PURE__ */ jsx23(Modal.Header, {
                        closeButton: true,
                        children: /* @__PURE__ */ jsx23(Modal.Title, {
                            children: contents.title
                        })
                    }),
                    /* @__PURE__ */ jsx23(Modal.Body, {
                        children: /* @__PURE__ */ jsx23("pre", {
                            children: contents.body
                        })
                    }),
                    /* @__PURE__ */ jsx23(Modal.Footer, {
                        children: /* @__PURE__ */ jsx23("button", {
                            className: "ds_button",
                            onClick: handleClose,
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
};
// src/lib/components/modal/modal-dynamic/modal-dynamic.tsx
import { Modal as Modal2 } from "react-bootstrap";
import ReactDOM from "react-dom";
// src/lib/components/buttons/buttonBase.tsx
import classNames2 from "classnames";
import { jsx as jsx24, jsxs as jsxs22 } from "react/jsx-runtime";
var ButtonBase = function(buttonProps) {
    var onClickHandler = function(e) {
        buttonProps.onClick(e);
    };
    var isPrimaryButton = function() {
        return !buttonProps.isCancel && !buttonProps.isWarning && !buttonProps.isSecondary;
    };
    return /* @__PURE__ */ jsxs22("button", {
        type: buttonProps.type,
        onClick: onClickHandler,
        disabled: buttonProps.disabled,
        className: classNames2("ds_button", {
            "ds_button--primary": isPrimaryButton(),
            "ds_button--small": buttonProps.smallButton,
            "ds_button--max": buttonProps.fullWidth,
            "ds_button--cancel": buttonProps.isCancel,
            "ds_button--secondary": buttonProps.isSecondary,
            "ds_button--warning": buttonProps.isWarning,
            "ds_button--fixed": buttonProps.isFixed
        }),
        children: [
            buttonProps.buttonText,
            " ",
            buttonProps.isLoading && /* @__PURE__ */ jsx24(loader_default, {
                loadingText: "",
                padding: "",
                size: "sm",
                variant: buttonProps.variant
            })
        ]
    });
};
// src/lib/components/buttons/primary-button/primary-button.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var PrimaryButton = function(buttonProps) {
    return /* @__PURE__ */ jsx25(ButtonBase, _object_spread({}, buttonProps));
};
var primary_button_default = PrimaryButton;
// src/lib/components/buttons/cancel-button/cancel-button.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var CancelButton = function(buttonProps) {
    return /* @__PURE__ */ jsx26(ButtonBase, _object_spread_props(_object_spread({}, buttonProps), {
        isCancel: true
    }));
};
var cancel_button_default = CancelButton;
// src/lib/components/modal/modal-dynamic/modal-dynamic.tsx
import { Fragment as Fragment7, jsx as jsx27, jsxs as jsxs23 } from "react/jsx-runtime";
var ModalDynamic = function(modalDynamicProps) {
    var modal = /* @__PURE__ */ jsxs23(Modal2, {
        show: true,
        backdrop: "static",
        keyboard: true,
        centered: true,
        children: [
            /* @__PURE__ */ jsx27(Modal2.Header, {
                closeButton: true,
                onHide: modalDynamicProps.onCancel,
                children: /* @__PURE__ */ jsx27(Modal2.Title, {
                    children: modalDynamicProps.contents.title !== void 0 ? modalDynamicProps.contents.title : "Confirm"
                })
            }),
            /* @__PURE__ */ jsx27(Modal2.Body, {
                children: modalDynamicProps.contents.summary ? /* @__PURE__ */ jsxs23(Fragment7, {
                    children: [
                        /* @__PURE__ */ jsx27("p", {
                            children: modalDynamicProps.contents.summary
                        }),
                        modalDynamicProps.contents.body
                    ]
                }) : /* @__PURE__ */ jsxs23(Fragment7, {
                    children: [
                        modalDynamicProps.contents.body,
                        " "
                    ]
                })
            }),
            /* @__PURE__ */ jsxs23(Modal2.Footer, {
                children: [
                    /* @__PURE__ */ jsx27(primary_button_default, {
                        buttonText: "Ok",
                        onClick: modalDynamicProps.onConfirm
                    }),
                    !modalDynamicProps.hideCancel && /* @__PURE__ */ jsx27(cancel_button_default, {
                        buttonText: "Cancel",
                        onClick: modalDynamicProps.onCancel
                    })
                ]
            })
        ]
    });
    return modalDynamicProps.show ? ReactDOM.createPortal(modal, document.body) : null;
};
// src/lib/components/phase-banner/phase-banner.tsx
import { jsx as jsx28, jsxs as jsxs24 } from "react/jsx-runtime";
var PhaseBanner = function(phaseBannerProps) {
    return /* @__PURE__ */ jsx28("div", {
        className: "ds_phase-banner",
        children: /* @__PURE__ */ jsx28("div", {
            className: "ds_wrapper",
            children: /* @__PURE__ */ jsxs24("p", {
                className: "ds_phase-banner__content",
                children: [
                    /* @__PURE__ */ jsx28("strong", {
                        className: "ds_tag  ds_phase-banner__tag",
                        children: phaseBannerProps.tag
                    }),
                    /* @__PURE__ */ jsxs24("span", {
                        className: "ds_phase-banner__text",
                        children: [
                            phaseBannerProps.text1,
                            " ",
                            /* @__PURE__ */ jsx28("a", {
                                href: phaseBannerProps.link,
                                children: phaseBannerProps.linkText
                            }),
                            " ",
                            phaseBannerProps.text2
                        ]
                    })
                ]
            })
        })
    });
};
// src/lib/components/foi/foi.tsx
import { Fragment as Fragment8, jsx as jsx29, jsxs as jsxs25 } from "react/jsx-runtime";
var Foi = function(foiProps) {
    return /* @__PURE__ */ jsxs25(Fragment8, {
        children: [
            /* @__PURE__ */ jsx29(page_header_sg_default, {
                headerText: "Freedom of Information"
            }),
            /* @__PURE__ */ jsxs25("div", {
                className: "ds_layout__content",
                children: [
                    /* @__PURE__ */ jsx29("p", {
                        className: "ds_leader",
                        children: "The Freedom of Information (Scotland) Act 2002 introduces important new rights to access information held by public authorities and requires more proactive publication of information."
                    }),
                    /* @__PURE__ */ jsxs25("p", {
                        children: [
                            "Please refer to the",
                            " ",
                            /* @__PURE__ */ jsxs25("a", {
                                target: "_blank",
                                rel: "noreferrer",
                                href: foiProps.linkUrl,
                                children: [
                                    " ",
                                    foiProps.linkTitle
                                ]
                            }),
                            " ",
                            "to find out more information."
                        ]
                    })
                ]
            })
        ]
    });
};
// src/lib/components/accordions/accordion-sg/accordion-sg-lists.tsx
import { useState as useState6 } from "react";
import { jsx as jsx30, jsxs as jsxs26 } from "react/jsx-runtime";
var AccordionSgLists = function(accordionListProps) {
    var displayBlock = "block";
    var displayNone = "none";
    var _useState6 = _sliced_to_array(useState6([
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone,
        displayNone
    ]), 2), currentStyle = _useState6[0], setCurrentStyle = _useState6[1];
    var showBody = function(i) {
        var newArray = currentStyle.map(function(item, index) {
            if (index === i) {
                if (item === displayBlock) {
                    item = displayNone;
                } else {
                    item = displayBlock;
                }
            }
            return item;
        });
        setCurrentStyle(newArray);
    };
    var handleKeyPress = function(e, i) {
        if (e.key === "Enter") {
            showBody(i);
        }
    };
    return /* @__PURE__ */ jsx30("div", {
        className: "ds_accordion",
        "data-module": "ds-accordion",
        children: accordionListProps && accordionListProps.reviewFaqs.length > 0 && accordionListProps.reviewFaqs.map(function(item, index) {
            return /* @__PURE__ */ jsxs26("div", {
                className: "ds_accordion-item",
                onKeyDown: function(e) {
                    return handleKeyPress(e, index);
                },
                children: [
                    /* @__PURE__ */ jsx30("input", {
                        type: "checkbox",
                        className: "visually-hidden  ds_accordion-item__control",
                        id: "panel-" + (index + 1),
                        "aria-labelledby": "panel-" + (index + 1) + "-heading"
                    }),
                    /* @__PURE__ */ jsxs26("div", {
                        className: "ds_accordion-item__header",
                        onClick: function() {
                            return showBody(index);
                        },
                        children: [
                            /* @__PURE__ */ jsx30("h3", {
                                id: "panel-" + (index + 1) + "-heading",
                                className: "ds_accordion-item__title",
                                children: item.title
                            }),
                            /* @__PURE__ */ jsx30("span", {
                                className: "ds_accordion-item__indicator"
                            }),
                            /* @__PURE__ */ jsx30("label", {
                                className: "ds_accordion-item__label",
                                htmlFor: "panel-" + (index + 1),
                                children: /* @__PURE__ */ jsx30("span", {
                                    className: "visually-hidden",
                                    children: "Show this section"
                                })
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsxs26("div", {
                        className: "ds_accordion-item__body",
                        style: {
                            display: currentStyle[index]
                        },
                        children: [
                            /* @__PURE__ */ jsx30("pre", {
                                children: item.body
                            }),
                            item.listItems.length > 0 && /* @__PURE__ */ jsx30("ul", {
                                children: item.listItems.map(function(listItem, index2) {
                                    return /* @__PURE__ */ jsxs26("li", {
                                        children: [
                                            listItem.listItem,
                                            listItem.subList.length > 0 && /* @__PURE__ */ jsx30("ul", {
                                                children: listItem.subList.map(function(subItem, index3) {
                                                    return /* @__PURE__ */ jsx30("li", {
                                                        children: subItem
                                                    }, index3);
                                                })
                                            })
                                        ]
                                    }, index2);
                                })
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
// src/lib/components/accordions/accordion-bs.tsx
import { Accordion } from "react-bootstrap";
import { jsx as jsx31, jsxs as jsxs27 } from "react/jsx-runtime";
var AccordionBs = function(accordionProps) {
    return /* @__PURE__ */ jsx31(Accordion, {
        children: accordionProps && accordionProps.items.length > 0 && accordionProps.items.map(function(item, index) {
            return /* @__PURE__ */ jsxs27(Accordion.Item, {
                eventKey: index.toString(),
                children: [
                    /* @__PURE__ */ jsx31(Accordion.Header, {
                        children: item.title
                    }),
                    /* @__PURE__ */ jsx31(Accordion.Body, {
                        children: /* @__PURE__ */ jsx31("pre", {
                            children: item.body
                        })
                    })
                ]
            }, index);
        })
    });
};
// src/lib/components/accordions/accordion-bs-lists.tsx
import { Accordion as Accordion2 } from "react-bootstrap";
import { jsx as jsx32, jsxs as jsxs28 } from "react/jsx-runtime";
var AccordionBsLists = function(accordionListProps) {
    return /* @__PURE__ */ jsx32(Accordion2, {
        children: accordionListProps && accordionListProps.reviewFaqs.length > 0 && accordionListProps.reviewFaqs.map(function(item, index) {
            return /* @__PURE__ */ jsxs28(Accordion2.Item, {
                eventKey: index.toString(),
                children: [
                    /* @__PURE__ */ jsx32(Accordion2.Header, {
                        children: item.title
                    }),
                    /* @__PURE__ */ jsxs28(Accordion2.Body, {
                        children: [
                            /* @__PURE__ */ jsx32("pre", {
                                children: item.body
                            }),
                            item.listItems.length > 0 && /* @__PURE__ */ jsx32("ul", {
                                children: item.listItems.map(function(listItem, index2) {
                                    return /* @__PURE__ */ jsxs28("li", {
                                        children: [
                                            listItem.listItem,
                                            listItem.subList.length > 0 && /* @__PURE__ */ jsx32("ul", {
                                                children: listItem.subList.map(function(subItem, index3) {
                                                    return /* @__PURE__ */ jsx32("li", {
                                                        children: subItem
                                                    }, index3);
                                                })
                                            })
                                        ]
                                    }, index2);
                                })
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
// src/lib/components/accordions/accordion-sg/accordion-sg-test.tsx
import { jsx as jsx33, jsxs as jsxs29 } from "react/jsx-runtime";
// src/lib/components/accessibility/accessibility.tsx
import { Fragment as Fragment9, jsx as jsx34, jsxs as jsxs30 } from "react/jsx-runtime";
var Accessibility = function(accessibilityProps) {
    return /* @__PURE__ */ jsxs30(Fragment9, {
        children: [
            /* @__PURE__ */ jsx34(page_header_sg_default, {
                headerText: "Accessibility"
            }),
            /* @__PURE__ */ jsx34("p", {
                children: "We want our sites and apps to be accessible and usable by as many people as possible."
            }),
            /* @__PURE__ */ jsx34("p", {
                children: "We try to make our site more accessible by using:"
            }),
            /* @__PURE__ */ jsxs30("ul", {
                children: [
                    /* @__PURE__ */ jsx34("li", {
                        children: "easier-to-read colours"
                    }),
                    /* @__PURE__ */ jsx34("li", {
                        children: "larger fonts"
                    }),
                    /* @__PURE__ */ jsx34("li", {
                        children: "plain English"
                    }),
                    /* @__PURE__ */ jsx34("li", {
                        children: "keyboard only navigation"
                    })
                ]
            }),
            /* @__PURE__ */ jsx34("h2", {
                children: "Feedback"
            }),
            /* @__PURE__ */ jsxs30("p", {
                children: [
                    "If you cannot access any part of this site or want to report an accessibility problem, email",
                    " ",
                    /* @__PURE__ */ jsx34("a", {
                        href: "mailto:" + accessibilityProps.contactEmail,
                        children: accessibilityProps.contactEmail
                    }),
                    "."
                ]
            }),
            /* @__PURE__ */ jsx34("h2", {
                children: "Enforcement procedure"
            }),
            /* @__PURE__ */ jsxs30("p", {
                children: [
                    "The Equality and Human Rights Commission enforces the",
                    " ",
                    /* @__PURE__ */ jsx34("a", {
                        rel: "noreferrer",
                        target: "_blank",
                        href: "https://www.legislation.gov.uk/uksi/2018/952/regulation/4/made",
                        children: "accessibility regulations"
                    }),
                    " ",
                    "(the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018)."
                ]
            }),
            /* @__PURE__ */ jsxs30("p", {
                children: [
                    "If you're not happy with how we respond to your feedback, contact the",
                    " ",
                    /* @__PURE__ */ jsx34("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: "https://www.equalityadvisoryservice.com/",
                        children: "Equality Advisory and Support Service"
                    }),
                    " ",
                    ". They are an independent advice service. They will advise you on what to do next."
                ]
            }),
            accessibilityProps.additionalItems && accessibilityProps.additionalItems.map(function(item) {
                return /* @__PURE__ */ jsxs30(Fragment9, {
                    children: [
                        /* @__PURE__ */ jsx34("h2", {
                            children: item.title
                        }),
                        /* @__PURE__ */ jsx34("p", {
                            children: item.body
                        }),
                        /* @__PURE__ */ jsx34("a", {
                            target: "_blank",
                            href: item.url,
                            children: item.urlName
                        })
                    ]
                });
            }),
            /* @__PURE__ */ jsx34("h2", {
                children: "Compliance statement"
            }),
            /* @__PURE__ */ jsx34("p", {
                children: "The Scottish Courts & Tribunal Service commits to making its websites and apps accessible in line with the accessibility regulations. This website is fully compliant with the following exception(s):"
            }),
            /* @__PURE__ */ jsxs30("ul", {
                children: [
                    accessibilityProps.complianceIssues.map(function(item, index) {
                        return /* @__PURE__ */ jsx34("li", {
                            children: /* @__PURE__ */ jsx34("pre", {
                                className: "fw-bold",
                                children: item
                            })
                        }, index);
                    }),
                    accessibilityProps.complianceIssues.length === 0 && /* @__PURE__ */ jsx34("li", {
                        children: /* @__PURE__ */ jsx34("pre", {
                            className: "fw-bold",
                            children: "There are currently no issues with this website"
                        })
                    }, 1)
                ]
            }),
            /* @__PURE__ */ jsxs30("p", {
                children: [
                    "This accessibility statement applies to this site and it was prepared on",
                    " ",
                    accessibilityProps.datePrepared
                ]
            })
        ]
    });
};
// src/lib/components/warning-text/warning-text.tsx
import { jsx as jsx35, jsxs as jsxs31 } from "react/jsx-runtime";
var WarningText = function(warningProps) {
    return /* @__PURE__ */ jsxs31("div", {
        className: "ds_warning-text",
        children: [
            /* @__PURE__ */ jsx35("strong", {
                className: "ds_warning-text__icon",
                "aria-hidden": "true"
            }),
            /* @__PURE__ */ jsx35("strong", {
                className: "visually-hidden",
                children: "Warning"
            }),
            /* @__PURE__ */ jsx35("div", {
                className: "ds_warning-text__text",
                children: warningProps.warningText
            })
        ]
    });
};
// src/lib/components/buttons/secondary-button/secondary-button.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var SecondaryButton = function(buttonProps) {
    return /* @__PURE__ */ jsx36(ButtonBase, _object_spread_props(_object_spread({}, buttonProps), {
        isSecondary: true
    }));
};
// src/lib/components/buttons/warning-button/warning-button.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var WarningButton = function(buttonProps) {
    return /* @__PURE__ */ jsx37(ButtonBase, _object_spread_props(_object_spread({}, buttonProps), {
        isWarning: true
    }));
};
// src/lib/components/navigation/card/nav-card.tsx
import { Link as Link4 } from "react-router-dom";
import { Fragment as Fragment10, jsx as jsx38, jsxs as jsxs32 } from "react/jsx-runtime";
var NavCard = function(props) {
    return /* @__PURE__ */ jsx38(Fragment10, {
        children: /* @__PURE__ */ jsx38("nav", {
            "aria-label": "Category navigation",
            children: /* @__PURE__ */ jsx38("ul", {
                className: "ds_category-list  ds_category-list--grid  ds_category-list--narrow",
                children: props.items.map(function(item, index) {
                    return /* @__PURE__ */ jsx38("li", {
                        className: "ds_card  ds_card--has-hover",
                        children: /* @__PURE__ */ jsxs32("article", {
                            className: "ds_category-item  ds_category-item--card",
                            children: [
                                /* @__PURE__ */ jsx38("h2", {
                                    className: "ds_category-item__title",
                                    children: item.isAnchorTag ? /* @__PURE__ */ jsxs32("a", {
                                        href: item.routeUri,
                                        className: "ds_category-item__link",
                                        children: [
                                            " ",
                                            item.header
                                        ]
                                    }) : /* @__PURE__ */ jsx38(Link4, {
                                        to: item.routeUri,
                                        className: "ds_category-item__link",
                                        children: item.header
                                    })
                                }),
                                item.bodyParagraphs.map(function(bodyParagraph, index2) {
                                    return /* @__PURE__ */ jsx38("p", {
                                        className: "ds_category-item__summary mb-2",
                                        children: bodyParagraph
                                    }, index2);
                                })
                            ]
                        })
                    }, index);
                })
            })
        })
    });
};
// src/lib/components/input/input.tsx
import { jsx as jsx39, jsxs as jsxs33 } from "react/jsx-runtime";
var Input = function(props) {
    var onChangeHandler = function onChangeHandler(e) {
        e.preventDefault();
        props.onChange(e.target.value);
    };
    return /* @__PURE__ */ jsxs33("div", {
        children: [
            /* @__PURE__ */ jsx39("label", {
                className: "ds_label",
                htmlFor: props.inputId,
                children: props.labelText
            }),
            /* @__PURE__ */ jsx39("input", {
                className: "ds_input",
                type: props.inputType,
                id: props.inputId,
                value: props.inputValue,
                onChange: function(e) {
                    return onChangeHandler(e);
                },
                placeholder: props.placeholder
            })
        ]
    });
};
var input_default = Input;
// src/lib/components/text-input/text-input.tsx
import classNames3 from "classnames";
import { forwardRef } from "react";
import { Fragment as Fragment11, jsx as jsx40, jsxs as jsxs34 } from "react/jsx-runtime";
var TextInput = forwardRef(function(param, ref) {
    var inputId = param.inputId, labelText = param.labelText, placeholder = param.placeholder, inputWidth = param.inputWidth, onChange = param.onChange;
    return /* @__PURE__ */ jsxs34(Fragment11, {
        children: [
            /* @__PURE__ */ jsx40("label", {
                className: "ds_label",
                htmlFor: inputId,
                children: labelText
            }),
            /* @__PURE__ */ jsx40("input", {
                ref: ref,
                className: classNames3("ds_input", "ds_input-wrapper", inputWidth),
                type: "text",
                id: inputId,
                name: inputId,
                placeholder: placeholder,
                onChange: function(e) {
                    return onChange(e.target.value);
                }
            })
        ]
    });
});
// src/lib/components/text-area/text-area.tsx
import classNames4 from "classnames";
import { forwardRef as forwardRef2 } from "react";
import { Fragment as Fragment12, jsx as jsx41, jsxs as jsxs35 } from "react/jsx-runtime";
var TextArea = forwardRef2(function(param, ref) {
    var id = param.id, labelText = param.labelText, _param_rows = param.rows, rows = _param_rows === void 0 ? 3 : _param_rows, placeholder = param.placeholder, width = param.width, onChange = param.onChange;
    return /* @__PURE__ */ jsxs35(Fragment12, {
        children: [
            /* @__PURE__ */ jsx41("label", {
                className: "ds_label",
                htmlFor: id,
                children: labelText
            }),
            /* @__PURE__ */ jsx41("textarea", {
                ref: ref,
                className: classNames4("ds_input", "ds_text-area-wrapper", width),
                rows: rows,
                id: id,
                name: id,
                placeholder: placeholder,
                onChange: function(e) {
                    return onChange(e.target.value);
                }
            })
        ]
    });
});
// src/lib/components/character-count/character-count.tsx
import { useEffect, useState as useState7 } from "react";
import { Fragment as Fragment13, jsx as jsx42, jsxs as jsxs36 } from "react/jsx-runtime";
var CharacterCount = function(param) {
    var charCount = param.charCount, maxLength = param.maxLength, children = param.children;
    var _useState7 = _sliced_to_array(useState7(""), 2), countMsg = _useState7[0], setCountMsg = _useState7[1];
    var _useState71 = _sliced_to_array(useState7(""), 2), countMsgScreenReader = _useState71[0], setCountMsgScreenReader = _useState71[1];
    useEffect(function() {
        var getCountMessage = function() {
            var charRemaining = Math.abs(maxLength - charCount);
            var noun = charRemaining > 1 ? "characters" : "character";
            return charRemaining === maxLength ? "You can enter up to ".concat(maxLength, " ").concat(noun) : charCount <= maxLength ? "You have ".concat(charRemaining, " ").concat(noun, " remaining") : "You have ".concat(charRemaining, " ").concat(noun, " too many");
        };
        return setCountMsg(getCountMessage());
    }, [
        charCount,
        maxLength
    ]);
    useEffect(function() {
        var timer = setTimeout(function() {
            setCountMsgScreenReader(countMsg);
        }, 1e3);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        countMsg
    ]);
    return /* @__PURE__ */ jsxs36(Fragment13, {
        children: [
            children,
            /* @__PURE__ */ jsx42("div", {
                className: "ds_input__message ds_hint-text ".concat(charCount > maxLength ? "ds_input__message--error" : ""),
                "aria-hidden": "true",
                children: countMsg
            }),
            /* @__PURE__ */ jsx42("div", {
                className: "visually-hidden",
                "aria-live": "polite",
                children: countMsgScreenReader
            })
        ]
    });
};
// src/lib/components/checkbox-component/single-checkbox/single-checkbox.tsx
import { jsx as jsx43, jsxs as jsxs37 } from "react/jsx-runtime";
var SingleCheckbox = function(singleCheckboxProps) {
    return /* @__PURE__ */ jsxs37("div", {
        className: "ds_checkbox",
        children: [
            /* @__PURE__ */ jsx43("input", {
                className: "ds_checkbox__input",
                id: singleCheckboxProps.inputId,
                type: "checkbox",
                checked: singleCheckboxProps.checked
            }),
            /* @__PURE__ */ jsx43("label", {
                className: "ds_checkbox__label",
                htmlFor: singleCheckboxProps.inputId,
                children: singleCheckboxProps.labelText
            })
        ]
    });
};
// src/lib/components/checkbox-component/dynamic-single-checkbox/dynamic-single-checkbox.tsx
import { useState as useState8 } from "react";
import { jsx as jsx44, jsxs as jsxs38 } from "react/jsx-runtime";
var DynamicSingleCheckbox = function(dynamicSingleCheckboxProps) {
    var onChangeHandler = function onChangeHandler(e) {
        setChecked(e.target.checked);
        dynamicSingleCheckboxProps.onChange(e);
    };
    var _useState8 = _sliced_to_array(useState8(dynamicSingleCheckboxProps.checked), 2), checked = _useState8[0], setChecked = _useState8[1];
    return /* @__PURE__ */ jsxs38("div", {
        className: "ds_checkbox",
        children: [
            /* @__PURE__ */ jsx44("input", {
                className: "ds_checkbox__input",
                id: dynamicSingleCheckboxProps.inputId,
                type: "checkbox",
                checked: checked,
                onChange: function(e) {
                    return onChangeHandler(e);
                }
            }),
            /* @__PURE__ */ jsx44("label", {
                className: "ds_checkbox__label",
                htmlFor: dynamicSingleCheckboxProps.labelId,
                children: dynamicSingleCheckboxProps.labelText
            })
        ]
    });
};
// src/lib/components/tab-component/tab-subcomponent/tab-subcomponent.tsx
import { Tabs as Tabs2, Tab as Tab2 } from "react-bootstrap";
import { jsx as jsx45 } from "react/jsx-runtime";
var TabSubComponent = function(tabSubcomponentProps) {
    var handleSelect = function(e) {
        return tabSubcomponentProps.onSelect ? tabSubcomponentProps.onSelect(e) : null;
    };
    return /* @__PURE__ */ jsx45("div", {
        className: "scts-tabs",
        children: /* @__PURE__ */ jsx45(Tabs2, {
            defaultActiveKey: tabSubcomponentProps.activeKey,
            transition: false,
            onSelect: handleSelect,
            children: tabSubcomponentProps.tabs.map(function(tab) {
                return /* @__PURE__ */ jsx45(Tab2, {
                    eventKey: tab.key,
                    title: tab.title,
                    children: /* @__PURE__ */ jsx45("div", {
                        className: "card",
                        children: /* @__PURE__ */ jsx45("div", {
                            className: "card-body",
                            children: tab.children
                        })
                    })
                }, tab.key);
            })
        })
    });
};
// src/lib/components/selects/select/select-component.tsx
import classNames5 from "classnames";
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx46, jsxs as jsxs39 } from "react/jsx-runtime";
var SelectComponent = forwardRef3(function(param, ref) {
    var selectId = param.selectId, selectedValue = param.selectedValue, selectedDisabled = param.selectedDisabled, selectLabelText = param.selectLabelText, selectName = param.selectName, selectOptions = param.selectOptions, _param_selectWidth = param.selectWidth, selectWidth = _param_selectWidth === void 0 ? "ds_input--fluid-one-third" : _param_selectWidth, onChange = param.onChange;
    var onChangeHandler = function(e) {
        e.preventDefault();
        onChange(e.target.options[e.target.options.selectedIndex]);
    };
    return /* @__PURE__ */ jsxs39("div", {
        children: [
            /* @__PURE__ */ jsx46("label", {
                className: "ds_label",
                htmlFor: selectId,
                children: selectLabelText
            }),
            /* @__PURE__ */ jsxs39("div", {
                className: classNames5("ds_select-wrapper", selectWidth),
                children: [
                    /* @__PURE__ */ jsx46("select", {
                        ref: ref,
                        className: "ds_select",
                        id: selectId,
                        value: selectedValue,
                        disabled: selectedDisabled,
                        name: selectName,
                        onChange: function(e) {
                            return onChangeHandler(e);
                        },
                        children: selectOptions.map(function(item) {
                            if (selectedValue === item.value) {
                                return /* @__PURE__ */ jsx46("option", {
                                    "data-optionid": item.key,
                                    id: selectId + "-" + item.key,
                                    value: item.value,
                                    "aria-selected": true,
                                    children: item.value
                                }, item.key);
                            } else {
                                return /* @__PURE__ */ jsx46("option", {
                                    "data-optionid": item.key,
                                    id: selectId + "-" + item.key,
                                    value: item.value,
                                    children: item.value
                                }, item.key);
                            }
                        })
                    }),
                    /* @__PURE__ */ jsx46("span", {
                        className: selectedDisabled ? "ds_select-arrow-disable" : "ds_select-arrow",
                        "aria-hidden": "true"
                    })
                ]
            })
        ]
    });
});
// src/lib/components/selects/select-with-opt-text/select-wot-component.tsx
import classNames6 from "classnames";
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx47, jsxs as jsxs40 } from "react/jsx-runtime";
var SelectWotComponent = forwardRef4(function(param, ref) {
    var selectId = param.selectId, selectedValue = param.selectedValue, selectedDisabled = param.selectedDisabled, selectLabelText = param.selectLabelText, selectName = param.selectName, selectOptions = param.selectOptions, _param_selectWidth = param.selectWidth, selectWidth = _param_selectWidth === void 0 ? "ds_input--fluid-one-third" : _param_selectWidth, onChange = param.onChange;
    var renderItems = function renderItems() {
        if (selectOptions) {
            return selectOptions.map(function(item) {
                return /* @__PURE__ */ jsx47("option", {
                    id: item.key,
                    value: item.value,
                    children: item.text
                }, item.key);
            });
        }
    };
    var onChangeHandler = function(e) {
        e.preventDefault();
        onChange(e.target.options[e.target.options.selectedIndex]);
    };
    return /* @__PURE__ */ jsxs40("div", {
        children: [
            /* @__PURE__ */ jsx47("label", {
                className: "ds_label",
                htmlFor: selectId,
                children: selectLabelText
            }),
            /* @__PURE__ */ jsxs40("div", {
                className: classNames6("ds_select-wrapper", selectWidth),
                children: [
                    /* @__PURE__ */ jsxs40("select", {
                        ref: ref,
                        className: "ds_select",
                        id: selectId,
                        value: selectedValue,
                        disabled: selectedDisabled,
                        name: selectName,
                        onChange: function(e) {
                            return onChangeHandler(e);
                        },
                        children: [
                            /* @__PURE__ */ jsx47("option", {
                                value: "",
                                children: " Please select "
                            }),
                            renderItems()
                        ]
                    }),
                    /* @__PURE__ */ jsx47("span", {
                        className: selectedDisabled ? "ds_select-arrow-disable" : "ds_select-arrow",
                        "aria-hidden": "true"
                    })
                ]
            })
        ]
    });
});
// src/lib/components/alert-component/alert-component.tsx
import { useEffect as useEffect2, useRef, useState as useState9 } from "react";
import { Alert as Alert2 } from "react-bootstrap";
import { Fragment as Fragment14, jsx as jsx48, jsxs as jsxs41 } from "react/jsx-runtime";
var AlertComponent = function(alertComponentProps) {
    var alertRef = useRef(null);
    var _useState9 = _sliced_to_array(useState9(true), 2), show = _useState9[0], setShow = _useState9[1];
    useEffect2(function() {
        if (show) {
            var _alertRef_current;
            (_alertRef_current = alertRef.current) === null || _alertRef_current === void 0 ? void 0 : _alertRef_current.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    }, [
        show
    ]);
    var handleOnClose = function() {
        setShow(false);
        if (alertComponentProps.onClose !== void 0) {
            alertComponentProps.onClose();
        }
    };
    return /* @__PURE__ */ jsx48(Fragment14, {
        children: show && /* @__PURE__ */ jsxs41(Alert2, {
            ref: alertRef,
            variant: alertComponentProps.type,
            onClose: function() {
                return handleOnClose();
            },
            dismissible: true,
            children: [
                /* @__PURE__ */ jsx48(Alert2.Heading, {
                    children: alertComponentProps.header
                }),
                typeof alertComponentProps.message == "string" ? /* @__PURE__ */ jsx48("p", {
                    children: alertComponentProps.message
                }) : alertComponentProps.message.map(function(message, index) {
                    return /* @__PURE__ */ jsx48("p", {
                        children: message
                    }, index);
                })
            ]
        })
    });
};
// src/lib/components/navigation/side-navbar/side-navbar.tsx
import { BrowserRouter, Link as Link5, Outlet } from "react-router-dom";
import { jsx as jsx49, jsxs as jsxs42 } from "react/jsx-runtime";
var SideNavbar = function(sideNavbarProps) {
    return /* @__PURE__ */ jsx49(BrowserRouter, {
        children: /* @__PURE__ */ jsxs42("div", {
            className: "row",
            children: [
                /* @__PURE__ */ jsx49("div", {
                    className: "col-sm-12 col-md-3",
                    children: /* @__PURE__ */ jsx49("nav", {
                        "aria-label": "Sections",
                        className: "ds_side-navigation",
                        "data-module": "ds-side-navigation",
                        children: /* @__PURE__ */ jsx49("ul", {
                            className: "ds_side-navigation__list",
                            id: "side-navigation-root",
                            children: /* @__PURE__ */ jsx49("li", {
                                className: "ds_side-navigation__item  ds_side-navigation__item--has-children  ds_side-navigation__item--has-children--expanded",
                                children: sideNavbarProps.linkArray.map(function(link) {
                                    return /* @__PURE__ */ jsx49(Link5, {
                                        to: link.linkURL,
                                        className: "ds_site-navigation__link",
                                        children: link.displayText
                                    });
                                })
                            })
                        })
                    })
                }),
                /* @__PURE__ */ jsx49("div", {
                    className: "col-sm-12 col-md-9",
                    children: /* @__PURE__ */ jsx49(Outlet, {})
                })
            ]
        })
    });
};
// src/lib/components/search/simple-search/search.tsx
import { jsx as jsx50, jsxs as jsxs43 } from "react/jsx-runtime";
var SearchComponent = function(searchProps) {
    var handleClick = function() {
        var inp = document.getElementById("my-search");
        searchProps.onClick(inp.value);
    };
    var handleKeyDown = function(e) {
        if (e.key === "Enter") {
            handleClick();
        }
    };
    return /* @__PURE__ */ jsxs43("div", {
        className: "ds_site-search  ds_site-search--collapsible",
        "data-module": "ds-site-search",
        children: [
            /* @__PURE__ */ jsx50("label", {
                className: "ds_label  visually-hidden",
                htmlFor: "site-search",
                children: searchProps.searchLabel
            }),
            /* @__PURE__ */ jsxs43("div", {
                className: "ds_input__wrapper  ds_input__wrapper--has-icon",
                children: [
                    /* @__PURE__ */ jsx50("input", {
                        id: "my-search",
                        className: "ds_input  ds_site-search__input",
                        type: "search",
                        placeholder: searchProps.searchLabel,
                        autoComplete: "off",
                        onKeyDown: handleKeyDown
                    }),
                    /* @__PURE__ */ jsxs43("button", {
                        type: "submit",
                        role: "button",
                        className: "ds_button",
                        onClick: handleClick,
                        children: [
                            /* @__PURE__ */ jsx50("span", {
                                className: "visually-hidden",
                                children: searchProps.searchLabel
                            }),
                            /* @__PURE__ */ jsx50("img", {
                                src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBVcGxvYWRlZCB0bzogU1ZHIFJlcG8sIHd3dy5zdmdyZXBvLmNvbSwgR2VuZXJhdG9yOiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4NCjxzdmcgZmlsbD0iI2ZmZmZmZiIgaGVpZ2h0PSI4MDBweCIgd2lkdGg9IjgwMHB4IiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIA0KCSB2aWV3Qm94PSIwIDAgNDg4LjQgNDg4LjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGQ9Ik0wLDIwMy4yNWMwLDExMi4xLDkxLjIsMjAzLjIsMjAzLjIsMjAzLjJjNTEuNiwwLDk4LjgtMTkuNCwxMzQuNy01MS4ybDEyOS41LDEyOS41YzIuNCwyLjQsNS41LDMuNiw4LjcsMy42DQoJCQlzNi4zLTEuMiw4LjctMy42YzQuOC00LjgsNC44LTEyLjUsMC0xNy4zbC0xMjkuNi0xMjkuNWMzMS44LTM1LjksNTEuMi04Myw1MS4yLTEzNC43YzAtMTEyLjEtOTEuMi0yMDMuMi0yMDMuMi0yMDMuMg0KCQkJUzAsOTEuMTUsMCwyMDMuMjV6IE0zODEuOSwyMDMuMjVjMCw5OC41LTgwLjIsMTc4LjctMTc4LjcsMTc4LjdzLTE3OC43LTgwLjItMTc4LjctMTc4LjdzODAuMi0xNzguNywxNzguNy0xNzguNw0KCQkJUzM4MS45LDEwNC42NSwzODEuOSwyMDMuMjV6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+",
                                "aria-hidden": "true",
                                className: "ds_icon",
                                alt: "search icon"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// src/lib/components/search/search-as-you-type/search-as-you-type.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
var SearchAsYouTypeComponent = function(searchAsYouTypeProps) {
    return /* @__PURE__ */ jsx51(input_default, {
        inputId: searchAsYouTypeProps.inputId,
        inputValue: searchAsYouTypeProps.inputValue,
        labelText: searchAsYouTypeProps.labelText,
        onChange: searchAsYouTypeProps.onSearch,
        inputType: searchAsYouTypeProps.inputType,
        placeholder: searchAsYouTypeProps.placeholder
    });
};
// src/lib/components/table/basic/table-defs-header.tsx
import { jsx as jsx52 } from "react/jsx-runtime";
var TableHeader = function(param) {
    var columns = param.columns;
    var headers = columns.map(function(column, index) {
        return /* @__PURE__ */ jsx52("th", {
            children: column.header
        }, "headCell-".concat(index));
    });
    return /* @__PURE__ */ jsx52("thead", {
        children: /* @__PURE__ */ jsx52("tr", {
            children: headers
        })
    });
};
var table_defs_header_default = TableHeader;
// src/lib/components/table/basic/table-defs-rows.tsx
import { jsx as jsx53 } from "react/jsx-runtime";
var TableRows = function(param) {
    var data = param.data, columns = param.columns;
    var rows = data.map(function(row, index) {
        return /* @__PURE__ */ jsx53("tr", {
            children: columns.map(function(column, index2) {
                return !column.isLink ? /* @__PURE__ */ jsx53("td", {
                    "data-heading": column.header,
                    children: row[column.key]
                }, "cell-".concat(index2)) : /* @__PURE__ */ jsx53("td", {
                    "data-heading": column.header,
                    children: row[column.key].trim() != "" ? /* @__PURE__ */ jsx53("a", {
                        href: "#",
                        className: column.classNames,
                        onClick: function(e) {
                            return column.onClickHandler(e, row);
                        },
                        children: row[column.key]
                    }) : ""
                }, "cell-".concat(index2));
            })
        }, "row-".concat(index));
    });
    return /* @__PURE__ */ jsx53("tbody", {
        children: rows
    });
};
var table_defs_rows_default = TableRows;
// src/lib/components/table/basic/table-basic.tsx
import { jsx as jsx54, jsxs as jsxs44 } from "react/jsx-runtime";
var TableBasic = function(param) {
    var data = param.data, columns = param.columns, _param_showMobileBoxes = param.showMobileBoxes, showMobileBoxes = _param_showMobileBoxes === void 0 ? true : _param_showMobileBoxes;
    return /* @__PURE__ */ jsx54("div", {
        className: showMobileBoxes ? "js-enabled" : "table-responsive",
        children: /* @__PURE__ */ jsxs44("table", {
            className: "ds_table",
            "data-smallscreen": showMobileBoxes ? "boxes" : "",
            children: [
                /* @__PURE__ */ jsx54(table_defs_header_default, {
                    columns: columns
                }),
                /* @__PURE__ */ jsx54(table_defs_rows_default, {
                    data: data,
                    columns: columns
                })
            ]
        })
    });
};
// src/lib/components/radio-buttons/radio-button.tsx
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx55, jsxs as jsxs45 } from "react/jsx-runtime";
var RadioButton = forwardRef5(function(radioButtonProps, ref) {
    var onChangeHandler = function(e) {
        radioButtonProps.onChange(e);
    };
    return /* @__PURE__ */ jsxs45("div", {
        className: "ds_radio",
        children: [
            /* @__PURE__ */ jsx55("input", {
                className: "ds_radio__input",
                ref: ref,
                id: radioButtonProps.inputId,
                name: radioButtonProps.name,
                value: radioButtonProps.value,
                type: "radio",
                defaultChecked: radioButtonProps.checked,
                onChange: function(e) {
                    return onChangeHandler(e);
                }
            }),
            /* @__PURE__ */ jsx55("label", {
                className: "ds_radio__label",
                htmlFor: radioButtonProps.inputId,
                children: radioButtonProps.labelText
            })
        ]
    });
});
var radio_button_default = RadioButton;
// src/lib/components/radio-buttons/radio-button-group.tsx
import { forwardRef as forwardRef6 } from "react";
import { jsx as jsx56 } from "react/jsx-runtime";
import { createElement } from "react";
var RadioButtonGroup = forwardRef6(function(radioButtonGroupProps, ref) {
    return /* @__PURE__ */ jsx56("div", {
        className: "ds_field-group",
        ref: ref,
        children: radioButtonGroupProps.radioButtons.map(function(item) {
            return /* @__PURE__ */ createElement(radio_button_default, _object_spread_props(_object_spread({}, item), {
                key: item.inputId,
                onChange: function(e) {
                    radioButtonGroupProps.onChange(e);
                    item.onChange(e);
                }
            }));
        })
    });
});
export { Accessibility, AccordionBs, AccordionBsLists, AccordionSg, AccordionSgLists, AlertBox, AlertComponent, CancelButton, CharacterCount, ContactSg, DynamicSingleCheckbox, ErrorSimple, Foi, Footer, FooterMulti, FooterSg, FormHeader, FormItem, GoogleMap, Header, HeaderSg, Input, Loader, ModalDynamic, ModalStatic, NavCard, NotFound, PageHeader, PageHeaderSg, PagingSg, PhaseBanner, PrimaryButton, RadioButton, RadioButtonGroup, SearchAsYouTypeComponent, SearchComponent, SecondaryButton, SelectComponent, SelectWotComponent, SideNavbar, SingleCheckbox, TabComponent, TabSubComponent, TableBasic, TextArea, TextInput, Timeline, TimelineSteps, WarningButton, WarningText };
